/**
 * @fileoverview gRPC-Web generated client stub for claims_bff_api
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v6.31.1
// source: claims-bff.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as messages_auth_message_pb from './messages/auth.message_pb'; // proto import: "messages/auth.message.proto"
import * as messages_benefits_message_pb from './messages/benefits.message_pb'; // proto import: "messages/benefits.message.proto"
import * as messages_cases_message_pb from './messages/cases.message_pb'; // proto import: "messages/cases.message.proto"
import * as messages_claims_message_pb from './messages/claims.message_pb'; // proto import: "messages/claims.message.proto"
import * as messages_core_message_pb from './messages/core.message_pb'; // proto import: "messages/core.message.proto"
import * as messages_file_message_pb from './messages/file.message_pb'; // proto import: "messages/file.message.proto"
import * as messages_members_message_pb from './messages/members.message_pb'; // proto import: "messages/members.message.proto"
import * as messages_payments_message_pb from './messages/payments.message_pb'; // proto import: "messages/payments.message.proto"
import * as messages_pdf_message_pb from './messages/pdf.message_pb'; // proto import: "messages/pdf.message.proto"
import * as messages_providers_message_pb from './messages/providers.message_pb'; // proto import: "messages/providers.message.proto"


export class ClaimsBFFControllerClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorMe = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/Me',
    grpcWeb.MethodType.UNARY,
    messages_auth_message_pb.AuthRequest,
    messages_auth_message_pb.AuthResponse,
    (request: messages_auth_message_pb.AuthRequest) => {
      return request.serializeBinary();
    },
    messages_auth_message_pb.AuthResponse.deserializeBinary
  );

  me(
    request: messages_auth_message_pb.AuthRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_auth_message_pb.AuthResponse>;

  me(
    request: messages_auth_message_pb.AuthRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.AuthResponse) => void): grpcWeb.ClientReadableStream<messages_auth_message_pb.AuthResponse>;

  me(
    request: messages_auth_message_pb.AuthRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.AuthResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/Me',
        request,
        metadata || {},
        this.methodDescriptorMe,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/Me',
    request,
    metadata || {},
    this.methodDescriptorMe);
  }

  methodDescriptorCreateUser = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/CreateUser',
    grpcWeb.MethodType.UNARY,
    messages_auth_message_pb.CreateUserRequest,
    messages_auth_message_pb.CreateUserResponse,
    (request: messages_auth_message_pb.CreateUserRequest) => {
      return request.serializeBinary();
    },
    messages_auth_message_pb.CreateUserResponse.deserializeBinary
  );

  createUser(
    request: messages_auth_message_pb.CreateUserRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_auth_message_pb.CreateUserResponse>;

  createUser(
    request: messages_auth_message_pb.CreateUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.CreateUserResponse) => void): grpcWeb.ClientReadableStream<messages_auth_message_pb.CreateUserResponse>;

  createUser(
    request: messages_auth_message_pb.CreateUserRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.CreateUserResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/CreateUser',
        request,
        metadata || {},
        this.methodDescriptorCreateUser,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/CreateUser',
    request,
    metadata || {},
    this.methodDescriptorCreateUser);
  }

  methodDescriptorUpsertUser = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/UpsertUser',
    grpcWeb.MethodType.UNARY,
    messages_auth_message_pb.UpsertUserRequest,
    messages_auth_message_pb.UpsertUserResponse,
    (request: messages_auth_message_pb.UpsertUserRequest) => {
      return request.serializeBinary();
    },
    messages_auth_message_pb.UpsertUserResponse.deserializeBinary
  );

  upsertUser(
    request: messages_auth_message_pb.UpsertUserRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_auth_message_pb.UpsertUserResponse>;

  upsertUser(
    request: messages_auth_message_pb.UpsertUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.UpsertUserResponse) => void): grpcWeb.ClientReadableStream<messages_auth_message_pb.UpsertUserResponse>;

  upsertUser(
    request: messages_auth_message_pb.UpsertUserRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.UpsertUserResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/UpsertUser',
        request,
        metadata || {},
        this.methodDescriptorUpsertUser,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/UpsertUser',
    request,
    metadata || {},
    this.methodDescriptorUpsertUser);
  }

  methodDescriptorLogin = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/Login',
    grpcWeb.MethodType.UNARY,
    messages_auth_message_pb.LoginRequest,
    messages_auth_message_pb.LoginResponse,
    (request: messages_auth_message_pb.LoginRequest) => {
      return request.serializeBinary();
    },
    messages_auth_message_pb.LoginResponse.deserializeBinary
  );

  login(
    request: messages_auth_message_pb.LoginRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_auth_message_pb.LoginResponse>;

  login(
    request: messages_auth_message_pb.LoginRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.LoginResponse) => void): grpcWeb.ClientReadableStream<messages_auth_message_pb.LoginResponse>;

  login(
    request: messages_auth_message_pb.LoginRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.LoginResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/Login',
        request,
        metadata || {},
        this.methodDescriptorLogin,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/Login',
    request,
    metadata || {},
    this.methodDescriptorLogin);
  }

  methodDescriptorLoginAD = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/LoginAD',
    grpcWeb.MethodType.UNARY,
    messages_auth_message_pb.LoginRequest,
    messages_auth_message_pb.LoginResponse,
    (request: messages_auth_message_pb.LoginRequest) => {
      return request.serializeBinary();
    },
    messages_auth_message_pb.LoginResponse.deserializeBinary
  );

  loginAD(
    request: messages_auth_message_pb.LoginRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_auth_message_pb.LoginResponse>;

  loginAD(
    request: messages_auth_message_pb.LoginRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.LoginResponse) => void): grpcWeb.ClientReadableStream<messages_auth_message_pb.LoginResponse>;

  loginAD(
    request: messages_auth_message_pb.LoginRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.LoginResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/LoginAD',
        request,
        metadata || {},
        this.methodDescriptorLoginAD,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/LoginAD',
    request,
    metadata || {},
    this.methodDescriptorLoginAD);
  }

  methodDescriptorRefreshToken = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/RefreshToken',
    grpcWeb.MethodType.UNARY,
    messages_auth_message_pb.RefreshTokenRequest,
    messages_auth_message_pb.RefreshTokenResponse,
    (request: messages_auth_message_pb.RefreshTokenRequest) => {
      return request.serializeBinary();
    },
    messages_auth_message_pb.RefreshTokenResponse.deserializeBinary
  );

  refreshToken(
    request: messages_auth_message_pb.RefreshTokenRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_auth_message_pb.RefreshTokenResponse>;

  refreshToken(
    request: messages_auth_message_pb.RefreshTokenRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.RefreshTokenResponse) => void): grpcWeb.ClientReadableStream<messages_auth_message_pb.RefreshTokenResponse>;

  refreshToken(
    request: messages_auth_message_pb.RefreshTokenRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.RefreshTokenResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/RefreshToken',
        request,
        metadata || {},
        this.methodDescriptorRefreshToken,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/RefreshToken',
    request,
    metadata || {},
    this.methodDescriptorRefreshToken);
  }

  methodDescriptorRevokeToken = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/RevokeToken',
    grpcWeb.MethodType.UNARY,
    messages_auth_message_pb.RevokeTokenRequest,
    messages_auth_message_pb.RevokeTokenResponse,
    (request: messages_auth_message_pb.RevokeTokenRequest) => {
      return request.serializeBinary();
    },
    messages_auth_message_pb.RevokeTokenResponse.deserializeBinary
  );

  revokeToken(
    request: messages_auth_message_pb.RevokeTokenRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_auth_message_pb.RevokeTokenResponse>;

  revokeToken(
    request: messages_auth_message_pb.RevokeTokenRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.RevokeTokenResponse) => void): grpcWeb.ClientReadableStream<messages_auth_message_pb.RevokeTokenResponse>;

  revokeToken(
    request: messages_auth_message_pb.RevokeTokenRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.RevokeTokenResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/RevokeToken',
        request,
        metadata || {},
        this.methodDescriptorRevokeToken,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/RevokeToken',
    request,
    metadata || {},
    this.methodDescriptorRevokeToken);
  }

  methodDescriptorResendWelcome = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/ResendWelcome',
    grpcWeb.MethodType.UNARY,
    messages_auth_message_pb.ResendWelcomeRequest,
    messages_auth_message_pb.ResendWelcomeResponse,
    (request: messages_auth_message_pb.ResendWelcomeRequest) => {
      return request.serializeBinary();
    },
    messages_auth_message_pb.ResendWelcomeResponse.deserializeBinary
  );

  resendWelcome(
    request: messages_auth_message_pb.ResendWelcomeRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_auth_message_pb.ResendWelcomeResponse>;

  resendWelcome(
    request: messages_auth_message_pb.ResendWelcomeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.ResendWelcomeResponse) => void): grpcWeb.ClientReadableStream<messages_auth_message_pb.ResendWelcomeResponse>;

  resendWelcome(
    request: messages_auth_message_pb.ResendWelcomeRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.ResendWelcomeResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/ResendWelcome',
        request,
        metadata || {},
        this.methodDescriptorResendWelcome,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/ResendWelcome',
    request,
    metadata || {},
    this.methodDescriptorResendWelcome);
  }

  methodDescriptorRequestPasswordReset = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/RequestPasswordReset',
    grpcWeb.MethodType.UNARY,
    messages_auth_message_pb.RequestPasswordResetRequest,
    messages_auth_message_pb.RequestPasswordResetResponse,
    (request: messages_auth_message_pb.RequestPasswordResetRequest) => {
      return request.serializeBinary();
    },
    messages_auth_message_pb.RequestPasswordResetResponse.deserializeBinary
  );

  requestPasswordReset(
    request: messages_auth_message_pb.RequestPasswordResetRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_auth_message_pb.RequestPasswordResetResponse>;

  requestPasswordReset(
    request: messages_auth_message_pb.RequestPasswordResetRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.RequestPasswordResetResponse) => void): grpcWeb.ClientReadableStream<messages_auth_message_pb.RequestPasswordResetResponse>;

  requestPasswordReset(
    request: messages_auth_message_pb.RequestPasswordResetRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.RequestPasswordResetResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/RequestPasswordReset',
        request,
        metadata || {},
        this.methodDescriptorRequestPasswordReset,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/RequestPasswordReset',
    request,
    metadata || {},
    this.methodDescriptorRequestPasswordReset);
  }

  methodDescriptorResetPassword = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/ResetPassword',
    grpcWeb.MethodType.UNARY,
    messages_auth_message_pb.ResetPasswordRequest,
    messages_auth_message_pb.ResetPasswordResponse,
    (request: messages_auth_message_pb.ResetPasswordRequest) => {
      return request.serializeBinary();
    },
    messages_auth_message_pb.ResetPasswordResponse.deserializeBinary
  );

  resetPassword(
    request: messages_auth_message_pb.ResetPasswordRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_auth_message_pb.ResetPasswordResponse>;

  resetPassword(
    request: messages_auth_message_pb.ResetPasswordRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.ResetPasswordResponse) => void): grpcWeb.ClientReadableStream<messages_auth_message_pb.ResetPasswordResponse>;

  resetPassword(
    request: messages_auth_message_pb.ResetPasswordRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.ResetPasswordResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/ResetPassword',
        request,
        metadata || {},
        this.methodDescriptorResetPassword,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/ResetPassword',
    request,
    metadata || {},
    this.methodDescriptorResetPassword);
  }

  methodDescriptorGetUsers = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetUsers',
    grpcWeb.MethodType.UNARY,
    messages_auth_message_pb.GetUsersRequest,
    messages_auth_message_pb.GetUsersResponse,
    (request: messages_auth_message_pb.GetUsersRequest) => {
      return request.serializeBinary();
    },
    messages_auth_message_pb.GetUsersResponse.deserializeBinary
  );

  getUsers(
    request: messages_auth_message_pb.GetUsersRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_auth_message_pb.GetUsersResponse>;

  getUsers(
    request: messages_auth_message_pb.GetUsersRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.GetUsersResponse) => void): grpcWeb.ClientReadableStream<messages_auth_message_pb.GetUsersResponse>;

  getUsers(
    request: messages_auth_message_pb.GetUsersRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.GetUsersResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetUsers',
        request,
        metadata || {},
        this.methodDescriptorGetUsers,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetUsers',
    request,
    metadata || {},
    this.methodDescriptorGetUsers);
  }

  methodDescriptorGetUserById = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetUserById',
    grpcWeb.MethodType.UNARY,
    messages_auth_message_pb.GetUserByIdRequest,
    messages_auth_message_pb.GetUserByIdResponse,
    (request: messages_auth_message_pb.GetUserByIdRequest) => {
      return request.serializeBinary();
    },
    messages_auth_message_pb.GetUserByIdResponse.deserializeBinary
  );

  getUserById(
    request: messages_auth_message_pb.GetUserByIdRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_auth_message_pb.GetUserByIdResponse>;

  getUserById(
    request: messages_auth_message_pb.GetUserByIdRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.GetUserByIdResponse) => void): grpcWeb.ClientReadableStream<messages_auth_message_pb.GetUserByIdResponse>;

  getUserById(
    request: messages_auth_message_pb.GetUserByIdRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.GetUserByIdResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetUserById',
        request,
        metadata || {},
        this.methodDescriptorGetUserById,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetUserById',
    request,
    metadata || {},
    this.methodDescriptorGetUserById);
  }

  methodDescriptorGetUserDataById = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetUserDataById',
    grpcWeb.MethodType.UNARY,
    messages_auth_message_pb.GetUserDataByIdRequest,
    messages_auth_message_pb.GetUserDataByIdResponse,
    (request: messages_auth_message_pb.GetUserDataByIdRequest) => {
      return request.serializeBinary();
    },
    messages_auth_message_pb.GetUserDataByIdResponse.deserializeBinary
  );

  getUserDataById(
    request: messages_auth_message_pb.GetUserDataByIdRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_auth_message_pb.GetUserDataByIdResponse>;

  getUserDataById(
    request: messages_auth_message_pb.GetUserDataByIdRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.GetUserDataByIdResponse) => void): grpcWeb.ClientReadableStream<messages_auth_message_pb.GetUserDataByIdResponse>;

  getUserDataById(
    request: messages_auth_message_pb.GetUserDataByIdRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_auth_message_pb.GetUserDataByIdResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetUserDataById',
        request,
        metadata || {},
        this.methodDescriptorGetUserDataById,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetUserDataById',
    request,
    metadata || {},
    this.methodDescriptorGetUserDataById);
  }

  methodDescriptorGet = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/Get',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.ClaimsGetClaimRequest,
    messages_claims_message_pb.ClaimsGetClaimResponse,
    (request: messages_claims_message_pb.ClaimsGetClaimRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.ClaimsGetClaimResponse.deserializeBinary
  );

  get(
    request: messages_claims_message_pb.ClaimsGetClaimRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.ClaimsGetClaimResponse>;

  get(
    request: messages_claims_message_pb.ClaimsGetClaimRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsGetClaimResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.ClaimsGetClaimResponse>;

  get(
    request: messages_claims_message_pb.ClaimsGetClaimRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsGetClaimResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/Get',
        request,
        metadata || {},
        this.methodDescriptorGet,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/Get',
    request,
    metadata || {},
    this.methodDescriptorGet);
  }

  methodDescriptorGetClaimReports = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetClaimReports',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.GetClaimReportsRequest,
    messages_claims_message_pb.GetClaimReportsResponse,
    (request: messages_claims_message_pb.GetClaimReportsRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.GetClaimReportsResponse.deserializeBinary
  );

  getClaimReports(
    request: messages_claims_message_pb.GetClaimReportsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.GetClaimReportsResponse>;

  getClaimReports(
    request: messages_claims_message_pb.GetClaimReportsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetClaimReportsResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.GetClaimReportsResponse>;

  getClaimReports(
    request: messages_claims_message_pb.GetClaimReportsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetClaimReportsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetClaimReports',
        request,
        metadata || {},
        this.methodDescriptorGetClaimReports,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetClaimReports',
    request,
    metadata || {},
    this.methodDescriptorGetClaimReports);
  }

  methodDescriptorImportClaimReports = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/ImportClaimReports',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.ImportClaimReportsRequest,
    messages_claims_message_pb.ImportClaimReportsResponse,
    (request: messages_claims_message_pb.ImportClaimReportsRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.ImportClaimReportsResponse.deserializeBinary
  );

  importClaimReports(
    request: messages_claims_message_pb.ImportClaimReportsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.ImportClaimReportsResponse>;

  importClaimReports(
    request: messages_claims_message_pb.ImportClaimReportsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ImportClaimReportsResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.ImportClaimReportsResponse>;

  importClaimReports(
    request: messages_claims_message_pb.ImportClaimReportsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ImportClaimReportsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/ImportClaimReports',
        request,
        metadata || {},
        this.methodDescriptorImportClaimReports,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/ImportClaimReports',
    request,
    metadata || {},
    this.methodDescriptorImportClaimReports);
  }

  methodDescriptorUpsertClaim = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/UpsertClaim',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.UpsertClaimRequest,
    messages_claims_message_pb.UpsertClaimResponse,
    (request: messages_claims_message_pb.UpsertClaimRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.UpsertClaimResponse.deserializeBinary
  );

  upsertClaim(
    request: messages_claims_message_pb.UpsertClaimRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.UpsertClaimResponse>;

  upsertClaim(
    request: messages_claims_message_pb.UpsertClaimRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.UpsertClaimResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.UpsertClaimResponse>;

  upsertClaim(
    request: messages_claims_message_pb.UpsertClaimRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.UpsertClaimResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/UpsertClaim',
        request,
        metadata || {},
        this.methodDescriptorUpsertClaim,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/UpsertClaim',
    request,
    metadata || {},
    this.methodDescriptorUpsertClaim);
  }

  methodDescriptorList = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/List',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.ClaimsListRequest,
    messages_claims_message_pb.ClaimsListResponse,
    (request: messages_claims_message_pb.ClaimsListRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.ClaimsListResponse.deserializeBinary
  );

  list(
    request: messages_claims_message_pb.ClaimsListRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.ClaimsListResponse>;

  list(
    request: messages_claims_message_pb.ClaimsListRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsListResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.ClaimsListResponse>;

  list(
    request: messages_claims_message_pb.ClaimsListRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsListResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/List',
        request,
        metadata || {},
        this.methodDescriptorList,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/List',
    request,
    metadata || {},
    this.methodDescriptorList);
  }

  methodDescriptorSearch = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/Search',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.ClaimsSearchRequest,
    messages_claims_message_pb.ClaimsSearchResponse,
    (request: messages_claims_message_pb.ClaimsSearchRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.ClaimsSearchResponse.deserializeBinary
  );

  search(
    request: messages_claims_message_pb.ClaimsSearchRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.ClaimsSearchResponse>;

  search(
    request: messages_claims_message_pb.ClaimsSearchRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsSearchResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.ClaimsSearchResponse>;

  search(
    request: messages_claims_message_pb.ClaimsSearchRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsSearchResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/Search',
        request,
        metadata || {},
        this.methodDescriptorSearch,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/Search',
    request,
    metadata || {},
    this.methodDescriptorSearch);
  }

  methodDescriptorSubmit = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/Submit',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.ClaimsSubmitRequest,
    messages_claims_message_pb.ClaimsSubmitResponse,
    (request: messages_claims_message_pb.ClaimsSubmitRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.ClaimsSubmitResponse.deserializeBinary
  );

  submit(
    request: messages_claims_message_pb.ClaimsSubmitRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.ClaimsSubmitResponse>;

  submit(
    request: messages_claims_message_pb.ClaimsSubmitRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsSubmitResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.ClaimsSubmitResponse>;

  submit(
    request: messages_claims_message_pb.ClaimsSubmitRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsSubmitResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/Submit',
        request,
        metadata || {},
        this.methodDescriptorSubmit,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/Submit',
    request,
    metadata || {},
    this.methodDescriptorSubmit);
  }

  methodDescriptorApprove = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/Approve',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.ClaimsApproveRequest,
    messages_claims_message_pb.ClaimsApproveResponse,
    (request: messages_claims_message_pb.ClaimsApproveRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.ClaimsApproveResponse.deserializeBinary
  );

  approve(
    request: messages_claims_message_pb.ClaimsApproveRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.ClaimsApproveResponse>;

  approve(
    request: messages_claims_message_pb.ClaimsApproveRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsApproveResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.ClaimsApproveResponse>;

  approve(
    request: messages_claims_message_pb.ClaimsApproveRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsApproveResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/Approve',
        request,
        metadata || {},
        this.methodDescriptorApprove,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/Approve',
    request,
    metadata || {},
    this.methodDescriptorApprove);
  }

  methodDescriptorDeny = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/Deny',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.ClaimsDenyRequest,
    messages_claims_message_pb.ClaimsDenyResponse,
    (request: messages_claims_message_pb.ClaimsDenyRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.ClaimsDenyResponse.deserializeBinary
  );

  deny(
    request: messages_claims_message_pb.ClaimsDenyRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.ClaimsDenyResponse>;

  deny(
    request: messages_claims_message_pb.ClaimsDenyRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsDenyResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.ClaimsDenyResponse>;

  deny(
    request: messages_claims_message_pb.ClaimsDenyRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsDenyResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/Deny',
        request,
        metadata || {},
        this.methodDescriptorDeny,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/Deny',
    request,
    metadata || {},
    this.methodDescriptorDeny);
  }

  methodDescriptorInReview = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/InReview',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.ClaimsInReviewRequest,
    messages_claims_message_pb.ClaimsInReviewResponse,
    (request: messages_claims_message_pb.ClaimsInReviewRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.ClaimsInReviewResponse.deserializeBinary
  );

  inReview(
    request: messages_claims_message_pb.ClaimsInReviewRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.ClaimsInReviewResponse>;

  inReview(
    request: messages_claims_message_pb.ClaimsInReviewRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsInReviewResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.ClaimsInReviewResponse>;

  inReview(
    request: messages_claims_message_pb.ClaimsInReviewRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsInReviewResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/InReview',
        request,
        metadata || {},
        this.methodDescriptorInReview,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/InReview',
    request,
    metadata || {},
    this.methodDescriptorInReview);
  }

  methodDescriptorCancel = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/Cancel',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.ClaimsCancelRequest,
    messages_claims_message_pb.ClaimsCancelResponse,
    (request: messages_claims_message_pb.ClaimsCancelRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.ClaimsCancelResponse.deserializeBinary
  );

  cancel(
    request: messages_claims_message_pb.ClaimsCancelRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.ClaimsCancelResponse>;

  cancel(
    request: messages_claims_message_pb.ClaimsCancelRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsCancelResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.ClaimsCancelResponse>;

  cancel(
    request: messages_claims_message_pb.ClaimsCancelRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsCancelResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/Cancel',
        request,
        metadata || {},
        this.methodDescriptorCancel,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/Cancel',
    request,
    metadata || {},
    this.methodDescriptorCancel);
  }

  methodDescriptorUncancel = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/Uncancel',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.UncancelClaimRequest,
    messages_claims_message_pb.UncancelClaimResponse,
    (request: messages_claims_message_pb.UncancelClaimRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.UncancelClaimResponse.deserializeBinary
  );

  uncancel(
    request: messages_claims_message_pb.UncancelClaimRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.UncancelClaimResponse>;

  uncancel(
    request: messages_claims_message_pb.UncancelClaimRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.UncancelClaimResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.UncancelClaimResponse>;

  uncancel(
    request: messages_claims_message_pb.UncancelClaimRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.UncancelClaimResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/Uncancel',
        request,
        metadata || {},
        this.methodDescriptorUncancel,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/Uncancel',
    request,
    metadata || {},
    this.methodDescriptorUncancel);
  }

  methodDescriptorQueueForPayment = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/QueueForPayment',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.ClaimsQueueForPaymentRequest,
    messages_claims_message_pb.ClaimsQueueForPaymentResponse,
    (request: messages_claims_message_pb.ClaimsQueueForPaymentRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.ClaimsQueueForPaymentResponse.deserializeBinary
  );

  queueForPayment(
    request: messages_claims_message_pb.ClaimsQueueForPaymentRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.ClaimsQueueForPaymentResponse>;

  queueForPayment(
    request: messages_claims_message_pb.ClaimsQueueForPaymentRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsQueueForPaymentResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.ClaimsQueueForPaymentResponse>;

  queueForPayment(
    request: messages_claims_message_pb.ClaimsQueueForPaymentRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsQueueForPaymentResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/QueueForPayment',
        request,
        metadata || {},
        this.methodDescriptorQueueForPayment,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/QueueForPayment',
    request,
    metadata || {},
    this.methodDescriptorQueueForPayment);
  }

  methodDescriptorClosePaid = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/ClosePaid',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.ClaimsClosePaidRequest,
    messages_claims_message_pb.ClaimsClosePaidResponse,
    (request: messages_claims_message_pb.ClaimsClosePaidRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.ClaimsClosePaidResponse.deserializeBinary
  );

  closePaid(
    request: messages_claims_message_pb.ClaimsClosePaidRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.ClaimsClosePaidResponse>;

  closePaid(
    request: messages_claims_message_pb.ClaimsClosePaidRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsClosePaidResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.ClaimsClosePaidResponse>;

  closePaid(
    request: messages_claims_message_pb.ClaimsClosePaidRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsClosePaidResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/ClosePaid',
        request,
        metadata || {},
        this.methodDescriptorClosePaid,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/ClosePaid',
    request,
    metadata || {},
    this.methodDescriptorClosePaid);
  }

  methodDescriptorCloseNotPaid = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/CloseNotPaid',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.ClaimsCloseNotPaidRequest,
    messages_claims_message_pb.ClaimsCloseNotPaidResponse,
    (request: messages_claims_message_pb.ClaimsCloseNotPaidRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.ClaimsCloseNotPaidResponse.deserializeBinary
  );

  closeNotPaid(
    request: messages_claims_message_pb.ClaimsCloseNotPaidRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.ClaimsCloseNotPaidResponse>;

  closeNotPaid(
    request: messages_claims_message_pb.ClaimsCloseNotPaidRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsCloseNotPaidResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.ClaimsCloseNotPaidResponse>;

  closeNotPaid(
    request: messages_claims_message_pb.ClaimsCloseNotPaidRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsCloseNotPaidResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/CloseNotPaid',
        request,
        metadata || {},
        this.methodDescriptorCloseNotPaid,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/CloseNotPaid',
    request,
    metadata || {},
    this.methodDescriptorCloseNotPaid);
  }

  methodDescriptorCloseNotPaidGoodwill = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/CloseNotPaidGoodwill',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.ClaimsCloseNotPaidGoodwillRequest,
    messages_claims_message_pb.ClaimsCloseNotPaidGoodwillResponse,
    (request: messages_claims_message_pb.ClaimsCloseNotPaidGoodwillRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.ClaimsCloseNotPaidGoodwillResponse.deserializeBinary
  );

  closeNotPaidGoodwill(
    request: messages_claims_message_pb.ClaimsCloseNotPaidGoodwillRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.ClaimsCloseNotPaidGoodwillResponse>;

  closeNotPaidGoodwill(
    request: messages_claims_message_pb.ClaimsCloseNotPaidGoodwillRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsCloseNotPaidGoodwillResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.ClaimsCloseNotPaidGoodwillResponse>;

  closeNotPaidGoodwill(
    request: messages_claims_message_pb.ClaimsCloseNotPaidGoodwillRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsCloseNotPaidGoodwillResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/CloseNotPaidGoodwill',
        request,
        metadata || {},
        this.methodDescriptorCloseNotPaidGoodwill,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/CloseNotPaidGoodwill',
    request,
    metadata || {},
    this.methodDescriptorCloseNotPaidGoodwill);
  }

  methodDescriptorDuplicate = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/Duplicate',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.ClaimsDuplicateRequest,
    messages_claims_message_pb.ClaimsDuplicateResponse,
    (request: messages_claims_message_pb.ClaimsDuplicateRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.ClaimsDuplicateResponse.deserializeBinary
  );

  duplicate(
    request: messages_claims_message_pb.ClaimsDuplicateRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.ClaimsDuplicateResponse>;

  duplicate(
    request: messages_claims_message_pb.ClaimsDuplicateRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsDuplicateResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.ClaimsDuplicateResponse>;

  duplicate(
    request: messages_claims_message_pb.ClaimsDuplicateRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsDuplicateResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/Duplicate',
        request,
        metadata || {},
        this.methodDescriptorDuplicate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/Duplicate',
    request,
    metadata || {},
    this.methodDescriptorDuplicate);
  }

  methodDescriptorPendingProvider = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/PendingProvider',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.ClaimsPendingProviderRequest,
    messages_claims_message_pb.ClaimsPendingProviderResponse,
    (request: messages_claims_message_pb.ClaimsPendingProviderRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.ClaimsPendingProviderResponse.deserializeBinary
  );

  pendingProvider(
    request: messages_claims_message_pb.ClaimsPendingProviderRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.ClaimsPendingProviderResponse>;

  pendingProvider(
    request: messages_claims_message_pb.ClaimsPendingProviderRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsPendingProviderResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.ClaimsPendingProviderResponse>;

  pendingProvider(
    request: messages_claims_message_pb.ClaimsPendingProviderRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsPendingProviderResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/PendingProvider',
        request,
        metadata || {},
        this.methodDescriptorPendingProvider,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/PendingProvider',
    request,
    metadata || {},
    this.methodDescriptorPendingProvider);
  }

  methodDescriptorPendingVerification = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/PendingVerification',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.ClaimsPendingVerificationRequest,
    messages_claims_message_pb.ClaimsPendingVerificationResponse,
    (request: messages_claims_message_pb.ClaimsPendingVerificationRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.ClaimsPendingVerificationResponse.deserializeBinary
  );

  pendingVerification(
    request: messages_claims_message_pb.ClaimsPendingVerificationRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.ClaimsPendingVerificationResponse>;

  pendingVerification(
    request: messages_claims_message_pb.ClaimsPendingVerificationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsPendingVerificationResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.ClaimsPendingVerificationResponse>;

  pendingVerification(
    request: messages_claims_message_pb.ClaimsPendingVerificationRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsPendingVerificationResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/PendingVerification',
        request,
        metadata || {},
        this.methodDescriptorPendingVerification,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/PendingVerification',
    request,
    metadata || {},
    this.methodDescriptorPendingVerification);
  }

  methodDescriptorPendingInternalReview = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/PendingInternalReview',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.ClaimsPendingInternalReviewRequest,
    messages_claims_message_pb.ClaimsPendingInternalReviewResponse,
    (request: messages_claims_message_pb.ClaimsPendingInternalReviewRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.ClaimsPendingInternalReviewResponse.deserializeBinary
  );

  pendingInternalReview(
    request: messages_claims_message_pb.ClaimsPendingInternalReviewRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.ClaimsPendingInternalReviewResponse>;

  pendingInternalReview(
    request: messages_claims_message_pb.ClaimsPendingInternalReviewRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsPendingInternalReviewResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.ClaimsPendingInternalReviewResponse>;

  pendingInternalReview(
    request: messages_claims_message_pb.ClaimsPendingInternalReviewRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsPendingInternalReviewResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/PendingInternalReview',
        request,
        metadata || {},
        this.methodDescriptorPendingInternalReview,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/PendingInternalReview',
    request,
    metadata || {},
    this.methodDescriptorPendingInternalReview);
  }

  methodDescriptorGetOldestClaimForAnalyst = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetOldestClaimForAnalyst',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.GetOldestClaimForAnalystRequest,
    messages_claims_message_pb.GetOldestClaimForAnalystResponse,
    (request: messages_claims_message_pb.GetOldestClaimForAnalystRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.GetOldestClaimForAnalystResponse.deserializeBinary
  );

  getOldestClaimForAnalyst(
    request: messages_claims_message_pb.GetOldestClaimForAnalystRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.GetOldestClaimForAnalystResponse>;

  getOldestClaimForAnalyst(
    request: messages_claims_message_pb.GetOldestClaimForAnalystRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetOldestClaimForAnalystResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.GetOldestClaimForAnalystResponse>;

  getOldestClaimForAnalyst(
    request: messages_claims_message_pb.GetOldestClaimForAnalystRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetOldestClaimForAnalystResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetOldestClaimForAnalyst',
        request,
        metadata || {},
        this.methodDescriptorGetOldestClaimForAnalyst,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetOldestClaimForAnalyst',
    request,
    metadata || {},
    this.methodDescriptorGetOldestClaimForAnalyst);
  }

  methodDescriptorAssignAnalyst = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/AssignAnalyst',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.ClaimsAssignAnalystRequest,
    messages_claims_message_pb.ClaimsAssignAnalystResponse,
    (request: messages_claims_message_pb.ClaimsAssignAnalystRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.ClaimsAssignAnalystResponse.deserializeBinary
  );

  assignAnalyst(
    request: messages_claims_message_pb.ClaimsAssignAnalystRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.ClaimsAssignAnalystResponse>;

  assignAnalyst(
    request: messages_claims_message_pb.ClaimsAssignAnalystRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsAssignAnalystResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.ClaimsAssignAnalystResponse>;

  assignAnalyst(
    request: messages_claims_message_pb.ClaimsAssignAnalystRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsAssignAnalystResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/AssignAnalyst',
        request,
        metadata || {},
        this.methodDescriptorAssignAnalyst,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/AssignAnalyst',
    request,
    metadata || {},
    this.methodDescriptorAssignAnalyst);
  }

  methodDescriptorGetApprovedCountForAnalyst = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetApprovedCountForAnalyst',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.GetApprovedCountForAnalystRequest,
    messages_claims_message_pb.GetApprovedCountForAnalystResponse,
    (request: messages_claims_message_pb.GetApprovedCountForAnalystRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.GetApprovedCountForAnalystResponse.deserializeBinary
  );

  getApprovedCountForAnalyst(
    request: messages_claims_message_pb.GetApprovedCountForAnalystRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.GetApprovedCountForAnalystResponse>;

  getApprovedCountForAnalyst(
    request: messages_claims_message_pb.GetApprovedCountForAnalystRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetApprovedCountForAnalystResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.GetApprovedCountForAnalystResponse>;

  getApprovedCountForAnalyst(
    request: messages_claims_message_pb.GetApprovedCountForAnalystRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetApprovedCountForAnalystResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetApprovedCountForAnalyst',
        request,
        metadata || {},
        this.methodDescriptorGetApprovedCountForAnalyst,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetApprovedCountForAnalyst',
    request,
    metadata || {},
    this.methodDescriptorGetApprovedCountForAnalyst);
  }

  methodDescriptorUpsertChecklistItem = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/UpsertChecklistItem',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.UpsertChecklistItemRequest,
    messages_claims_message_pb.UpsertChecklistItemResponse,
    (request: messages_claims_message_pb.UpsertChecklistItemRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.UpsertChecklistItemResponse.deserializeBinary
  );

  upsertChecklistItem(
    request: messages_claims_message_pb.UpsertChecklistItemRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.UpsertChecklistItemResponse>;

  upsertChecklistItem(
    request: messages_claims_message_pb.UpsertChecklistItemRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.UpsertChecklistItemResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.UpsertChecklistItemResponse>;

  upsertChecklistItem(
    request: messages_claims_message_pb.UpsertChecklistItemRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.UpsertChecklistItemResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/UpsertChecklistItem',
        request,
        metadata || {},
        this.methodDescriptorUpsertChecklistItem,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/UpsertChecklistItem',
    request,
    metadata || {},
    this.methodDescriptorUpsertChecklistItem);
  }

  methodDescriptorGetChecklistTemplate = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetChecklistTemplate',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.GetChecklistTemplateRequest,
    messages_claims_message_pb.GetChecklistTemplateResponse,
    (request: messages_claims_message_pb.GetChecklistTemplateRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.GetChecklistTemplateResponse.deserializeBinary
  );

  getChecklistTemplate(
    request: messages_claims_message_pb.GetChecklistTemplateRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.GetChecklistTemplateResponse>;

  getChecklistTemplate(
    request: messages_claims_message_pb.GetChecklistTemplateRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetChecklistTemplateResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.GetChecklistTemplateResponse>;

  getChecklistTemplate(
    request: messages_claims_message_pb.GetChecklistTemplateRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetChecklistTemplateResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetChecklistTemplate',
        request,
        metadata || {},
        this.methodDescriptorGetChecklistTemplate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetChecklistTemplate',
    request,
    metadata || {},
    this.methodDescriptorGetChecklistTemplate);
  }

  methodDescriptorGetClaimDetailListing = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetClaimDetailListing',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.GetClaimDetailListingRequest,
    messages_claims_message_pb.GetClaimDetailListingResponse,
    (request: messages_claims_message_pb.GetClaimDetailListingRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.GetClaimDetailListingResponse.deserializeBinary
  );

  getClaimDetailListing(
    request: messages_claims_message_pb.GetClaimDetailListingRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.GetClaimDetailListingResponse>;

  getClaimDetailListing(
    request: messages_claims_message_pb.GetClaimDetailListingRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetClaimDetailListingResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.GetClaimDetailListingResponse>;

  getClaimDetailListing(
    request: messages_claims_message_pb.GetClaimDetailListingRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetClaimDetailListingResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetClaimDetailListing',
        request,
        metadata || {},
        this.methodDescriptorGetClaimDetailListing,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetClaimDetailListing',
    request,
    metadata || {},
    this.methodDescriptorGetClaimDetailListing);
  }

  methodDescriptorUpdateClaimsDueDates = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/UpdateClaimsDueDates',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.UpdateClaimsDueDatesRequest,
    messages_claims_message_pb.UpdateClaimsDueDatesResponse,
    (request: messages_claims_message_pb.UpdateClaimsDueDatesRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.UpdateClaimsDueDatesResponse.deserializeBinary
  );

  updateClaimsDueDates(
    request: messages_claims_message_pb.UpdateClaimsDueDatesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.UpdateClaimsDueDatesResponse>;

  updateClaimsDueDates(
    request: messages_claims_message_pb.UpdateClaimsDueDatesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.UpdateClaimsDueDatesResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.UpdateClaimsDueDatesResponse>;

  updateClaimsDueDates(
    request: messages_claims_message_pb.UpdateClaimsDueDatesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.UpdateClaimsDueDatesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/UpdateClaimsDueDates',
        request,
        metadata || {},
        this.methodDescriptorUpdateClaimsDueDates,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/UpdateClaimsDueDates',
    request,
    metadata || {},
    this.methodDescriptorUpdateClaimsDueDates);
  }

  methodDescriptorUpdateClaimsAssignees = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/UpdateClaimsAssignees',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.UpdateClaimsAssigneesRequest,
    messages_claims_message_pb.UpdateClaimsAssigneesResponse,
    (request: messages_claims_message_pb.UpdateClaimsAssigneesRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.UpdateClaimsAssigneesResponse.deserializeBinary
  );

  updateClaimsAssignees(
    request: messages_claims_message_pb.UpdateClaimsAssigneesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.UpdateClaimsAssigneesResponse>;

  updateClaimsAssignees(
    request: messages_claims_message_pb.UpdateClaimsAssigneesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.UpdateClaimsAssigneesResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.UpdateClaimsAssigneesResponse>;

  updateClaimsAssignees(
    request: messages_claims_message_pb.UpdateClaimsAssigneesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.UpdateClaimsAssigneesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/UpdateClaimsAssignees',
        request,
        metadata || {},
        this.methodDescriptorUpdateClaimsAssignees,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/UpdateClaimsAssignees',
    request,
    metadata || {},
    this.methodDescriptorUpdateClaimsAssignees);
  }

  methodDescriptorUpdateClaimsStatuses = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/UpdateClaimsStatuses',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.UpdateClaimsStatusesRequest,
    messages_claims_message_pb.UpdateClaimsStatusesResponse,
    (request: messages_claims_message_pb.UpdateClaimsStatusesRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.UpdateClaimsStatusesResponse.deserializeBinary
  );

  updateClaimsStatuses(
    request: messages_claims_message_pb.UpdateClaimsStatusesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.UpdateClaimsStatusesResponse>;

  updateClaimsStatuses(
    request: messages_claims_message_pb.UpdateClaimsStatusesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.UpdateClaimsStatusesResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.UpdateClaimsStatusesResponse>;

  updateClaimsStatuses(
    request: messages_claims_message_pb.UpdateClaimsStatusesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.UpdateClaimsStatusesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/UpdateClaimsStatuses',
        request,
        metadata || {},
        this.methodDescriptorUpdateClaimsStatuses,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/UpdateClaimsStatuses',
    request,
    metadata || {},
    this.methodDescriptorUpdateClaimsStatuses);
  }

  methodDescriptorUpdateClaimCleanDate = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/UpdateClaimCleanDate',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.UpdateClaimCleanDateRequest,
    messages_claims_message_pb.UpdateClaimCleanDateResponse,
    (request: messages_claims_message_pb.UpdateClaimCleanDateRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.UpdateClaimCleanDateResponse.deserializeBinary
  );

  updateClaimCleanDate(
    request: messages_claims_message_pb.UpdateClaimCleanDateRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.UpdateClaimCleanDateResponse>;

  updateClaimCleanDate(
    request: messages_claims_message_pb.UpdateClaimCleanDateRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.UpdateClaimCleanDateResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.UpdateClaimCleanDateResponse>;

  updateClaimCleanDate(
    request: messages_claims_message_pb.UpdateClaimCleanDateRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.UpdateClaimCleanDateResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/UpdateClaimCleanDate',
        request,
        metadata || {},
        this.methodDescriptorUpdateClaimCleanDate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/UpdateClaimCleanDate',
    request,
    metadata || {},
    this.methodDescriptorUpdateClaimCleanDate);
  }

  methodDescriptorAssociateDocs = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/AssociateDocs',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.ClaimsAssociateDocsRequest,
    messages_claims_message_pb.ClaimsAssociateDocsResponse,
    (request: messages_claims_message_pb.ClaimsAssociateDocsRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.ClaimsAssociateDocsResponse.deserializeBinary
  );

  associateDocs(
    request: messages_claims_message_pb.ClaimsAssociateDocsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.ClaimsAssociateDocsResponse>;

  associateDocs(
    request: messages_claims_message_pb.ClaimsAssociateDocsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsAssociateDocsResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.ClaimsAssociateDocsResponse>;

  associateDocs(
    request: messages_claims_message_pb.ClaimsAssociateDocsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsAssociateDocsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/AssociateDocs',
        request,
        metadata || {},
        this.methodDescriptorAssociateDocs,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/AssociateDocs',
    request,
    metadata || {},
    this.methodDescriptorAssociateDocs);
  }

  methodDescriptorAssociateDocsChunk = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/AssociateDocsChunk',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.ClaimsAssociateDocsChunkRequest,
    messages_claims_message_pb.ClaimsAssociateDocsChunkResponse,
    (request: messages_claims_message_pb.ClaimsAssociateDocsChunkRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.ClaimsAssociateDocsChunkResponse.deserializeBinary
  );

  associateDocsChunk(
    request: messages_claims_message_pb.ClaimsAssociateDocsChunkRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.ClaimsAssociateDocsChunkResponse>;

  associateDocsChunk(
    request: messages_claims_message_pb.ClaimsAssociateDocsChunkRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsAssociateDocsChunkResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.ClaimsAssociateDocsChunkResponse>;

  associateDocsChunk(
    request: messages_claims_message_pb.ClaimsAssociateDocsChunkRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ClaimsAssociateDocsChunkResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/AssociateDocsChunk',
        request,
        metadata || {},
        this.methodDescriptorAssociateDocsChunk,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/AssociateDocsChunk',
    request,
    metadata || {},
    this.methodDescriptorAssociateDocsChunk);
  }

  methodDescriptorRemoveAssociatedDocument = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/RemoveAssociatedDocument',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.RemoveAssociatedDocumentRequest,
    messages_claims_message_pb.RemoveAssociatedDocumentResponse,
    (request: messages_claims_message_pb.RemoveAssociatedDocumentRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.RemoveAssociatedDocumentResponse.deserializeBinary
  );

  removeAssociatedDocument(
    request: messages_claims_message_pb.RemoveAssociatedDocumentRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.RemoveAssociatedDocumentResponse>;

  removeAssociatedDocument(
    request: messages_claims_message_pb.RemoveAssociatedDocumentRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.RemoveAssociatedDocumentResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.RemoveAssociatedDocumentResponse>;

  removeAssociatedDocument(
    request: messages_claims_message_pb.RemoveAssociatedDocumentRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.RemoveAssociatedDocumentResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/RemoveAssociatedDocument',
        request,
        metadata || {},
        this.methodDescriptorRemoveAssociatedDocument,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/RemoveAssociatedDocument',
    request,
    metadata || {},
    this.methodDescriptorRemoveAssociatedDocument);
  }

  methodDescriptorRecoverAssociatedDocument = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/RecoverAssociatedDocument',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.RecoverAssociatedDocumentRequest,
    messages_claims_message_pb.RecoverAssociatedDocumentResponse,
    (request: messages_claims_message_pb.RecoverAssociatedDocumentRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.RecoverAssociatedDocumentResponse.deserializeBinary
  );

  recoverAssociatedDocument(
    request: messages_claims_message_pb.RecoverAssociatedDocumentRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.RecoverAssociatedDocumentResponse>;

  recoverAssociatedDocument(
    request: messages_claims_message_pb.RecoverAssociatedDocumentRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.RecoverAssociatedDocumentResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.RecoverAssociatedDocumentResponse>;

  recoverAssociatedDocument(
    request: messages_claims_message_pb.RecoverAssociatedDocumentRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.RecoverAssociatedDocumentResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/RecoverAssociatedDocument',
        request,
        metadata || {},
        this.methodDescriptorRecoverAssociatedDocument,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/RecoverAssociatedDocument',
    request,
    metadata || {},
    this.methodDescriptorRecoverAssociatedDocument);
  }

  methodDescriptorPermanentlyRemoveAssociatedDocument = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/PermanentlyRemoveAssociatedDocument',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.PermanentlyRemoveAssociatedDocumentRequest,
    messages_claims_message_pb.PermanentlyRemoveAssociatedDocumentResponse,
    (request: messages_claims_message_pb.PermanentlyRemoveAssociatedDocumentRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.PermanentlyRemoveAssociatedDocumentResponse.deserializeBinary
  );

  permanentlyRemoveAssociatedDocument(
    request: messages_claims_message_pb.PermanentlyRemoveAssociatedDocumentRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.PermanentlyRemoveAssociatedDocumentResponse>;

  permanentlyRemoveAssociatedDocument(
    request: messages_claims_message_pb.PermanentlyRemoveAssociatedDocumentRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.PermanentlyRemoveAssociatedDocumentResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.PermanentlyRemoveAssociatedDocumentResponse>;

  permanentlyRemoveAssociatedDocument(
    request: messages_claims_message_pb.PermanentlyRemoveAssociatedDocumentRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.PermanentlyRemoveAssociatedDocumentResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/PermanentlyRemoveAssociatedDocument',
        request,
        metadata || {},
        this.methodDescriptorPermanentlyRemoveAssociatedDocument,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/PermanentlyRemoveAssociatedDocument',
    request,
    metadata || {},
    this.methodDescriptorPermanentlyRemoveAssociatedDocument);
  }

  methodDescriptorDeleteService = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/DeleteService',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.DeleteServiceRequest,
    messages_claims_message_pb.DeleteServiceResponse,
    (request: messages_claims_message_pb.DeleteServiceRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.DeleteServiceResponse.deserializeBinary
  );

  deleteService(
    request: messages_claims_message_pb.DeleteServiceRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.DeleteServiceResponse>;

  deleteService(
    request: messages_claims_message_pb.DeleteServiceRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.DeleteServiceResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.DeleteServiceResponse>;

  deleteService(
    request: messages_claims_message_pb.DeleteServiceRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.DeleteServiceResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/DeleteService',
        request,
        metadata || {},
        this.methodDescriptorDeleteService,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/DeleteService',
    request,
    metadata || {},
    this.methodDescriptorDeleteService);
  }

  methodDescriptorDeleteBillings = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/DeleteBillings',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.DeleteBillingsRequest,
    messages_claims_message_pb.DeleteBillingsResponse,
    (request: messages_claims_message_pb.DeleteBillingsRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.DeleteBillingsResponse.deserializeBinary
  );

  deleteBillings(
    request: messages_claims_message_pb.DeleteBillingsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.DeleteBillingsResponse>;

  deleteBillings(
    request: messages_claims_message_pb.DeleteBillingsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.DeleteBillingsResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.DeleteBillingsResponse>;

  deleteBillings(
    request: messages_claims_message_pb.DeleteBillingsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.DeleteBillingsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/DeleteBillings',
        request,
        metadata || {},
        this.methodDescriptorDeleteBillings,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/DeleteBillings',
    request,
    metadata || {},
    this.methodDescriptorDeleteBillings);
  }

  methodDescriptorExportPaymentsToCsv = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/ExportPaymentsToCsv',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.ExportPaymentsToCsvRequest,
    messages_claims_message_pb.ExportPaymentsToCsvResponse,
    (request: messages_claims_message_pb.ExportPaymentsToCsvRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.ExportPaymentsToCsvResponse.deserializeBinary
  );

  exportPaymentsToCsv(
    request: messages_claims_message_pb.ExportPaymentsToCsvRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.ExportPaymentsToCsvResponse>;

  exportPaymentsToCsv(
    request: messages_claims_message_pb.ExportPaymentsToCsvRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ExportPaymentsToCsvResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.ExportPaymentsToCsvResponse>;

  exportPaymentsToCsv(
    request: messages_claims_message_pb.ExportPaymentsToCsvRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ExportPaymentsToCsvResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/ExportPaymentsToCsv',
        request,
        metadata || {},
        this.methodDescriptorExportPaymentsToCsv,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/ExportPaymentsToCsv',
    request,
    metadata || {},
    this.methodDescriptorExportPaymentsToCsv);
  }

  methodDescriptorExportPaymentsCsvStatus = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/ExportPaymentsCsvStatus',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.ExportPaymentsCsvStatusRequest,
    messages_claims_message_pb.ExportPaymentsCsvStatusResponse,
    (request: messages_claims_message_pb.ExportPaymentsCsvStatusRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.ExportPaymentsCsvStatusResponse.deserializeBinary
  );

  exportPaymentsCsvStatus(
    request: messages_claims_message_pb.ExportPaymentsCsvStatusRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.ExportPaymentsCsvStatusResponse>;

  exportPaymentsCsvStatus(
    request: messages_claims_message_pb.ExportPaymentsCsvStatusRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ExportPaymentsCsvStatusResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.ExportPaymentsCsvStatusResponse>;

  exportPaymentsCsvStatus(
    request: messages_claims_message_pb.ExportPaymentsCsvStatusRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ExportPaymentsCsvStatusResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/ExportPaymentsCsvStatus',
        request,
        metadata || {},
        this.methodDescriptorExportPaymentsCsvStatus,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/ExportPaymentsCsvStatus',
    request,
    metadata || {},
    this.methodDescriptorExportPaymentsCsvStatus);
  }

  methodDescriptorListPaymentExports = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/ListPaymentExports',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.PaymentExportListRequest,
    messages_claims_message_pb.PaymentExportListResponse,
    (request: messages_claims_message_pb.PaymentExportListRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.PaymentExportListResponse.deserializeBinary
  );

  listPaymentExports(
    request: messages_claims_message_pb.PaymentExportListRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.PaymentExportListResponse>;

  listPaymentExports(
    request: messages_claims_message_pb.PaymentExportListRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.PaymentExportListResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.PaymentExportListResponse>;

  listPaymentExports(
    request: messages_claims_message_pb.PaymentExportListRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.PaymentExportListResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/ListPaymentExports',
        request,
        metadata || {},
        this.methodDescriptorListPaymentExports,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/ListPaymentExports',
    request,
    metadata || {},
    this.methodDescriptorListPaymentExports);
  }

  methodDescriptorExportClaimsToCsv = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/ExportClaimsToCsv',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.ExportClaimsToCsvRequest,
    messages_claims_message_pb.ExportClaimsToCsvResponse,
    (request: messages_claims_message_pb.ExportClaimsToCsvRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.ExportClaimsToCsvResponse.deserializeBinary
  );

  exportClaimsToCsv(
    request: messages_claims_message_pb.ExportClaimsToCsvRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.ExportClaimsToCsvResponse>;

  exportClaimsToCsv(
    request: messages_claims_message_pb.ExportClaimsToCsvRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ExportClaimsToCsvResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.ExportClaimsToCsvResponse>;

  exportClaimsToCsv(
    request: messages_claims_message_pb.ExportClaimsToCsvRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ExportClaimsToCsvResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/ExportClaimsToCsv',
        request,
        metadata || {},
        this.methodDescriptorExportClaimsToCsv,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/ExportClaimsToCsv',
    request,
    metadata || {},
    this.methodDescriptorExportClaimsToCsv);
  }

  methodDescriptorDynamicExportToCsv = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/DynamicExportToCsv',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.DynamicExportToCsvRequest,
    messages_claims_message_pb.DynamicExportToCsvResponse,
    (request: messages_claims_message_pb.DynamicExportToCsvRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.DynamicExportToCsvResponse.deserializeBinary
  );

  dynamicExportToCsv(
    request: messages_claims_message_pb.DynamicExportToCsvRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.DynamicExportToCsvResponse>;

  dynamicExportToCsv(
    request: messages_claims_message_pb.DynamicExportToCsvRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.DynamicExportToCsvResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.DynamicExportToCsvResponse>;

  dynamicExportToCsv(
    request: messages_claims_message_pb.DynamicExportToCsvRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.DynamicExportToCsvResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/DynamicExportToCsv',
        request,
        metadata || {},
        this.methodDescriptorDynamicExportToCsv,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/DynamicExportToCsv',
    request,
    metadata || {},
    this.methodDescriptorDynamicExportToCsv);
  }

  methodDescriptorGetClaimsStatusReasons = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetClaimsStatusReasons',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.GetClaimsStatusReasonsRequest,
    messages_claims_message_pb.GetClaimsStatusReasonsResponse,
    (request: messages_claims_message_pb.GetClaimsStatusReasonsRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.GetClaimsStatusReasonsResponse.deserializeBinary
  );

  getClaimsStatusReasons(
    request: messages_claims_message_pb.GetClaimsStatusReasonsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.GetClaimsStatusReasonsResponse>;

  getClaimsStatusReasons(
    request: messages_claims_message_pb.GetClaimsStatusReasonsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetClaimsStatusReasonsResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.GetClaimsStatusReasonsResponse>;

  getClaimsStatusReasons(
    request: messages_claims_message_pb.GetClaimsStatusReasonsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetClaimsStatusReasonsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetClaimsStatusReasons',
        request,
        metadata || {},
        this.methodDescriptorGetClaimsStatusReasons,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetClaimsStatusReasons',
    request,
    metadata || {},
    this.methodDescriptorGetClaimsStatusReasons);
  }

  methodDescriptorUpsertClaimsStatusReasons = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/UpsertClaimsStatusReasons',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.UpsertClaimsStatusReasonsRequest,
    messages_claims_message_pb.UpsertClaimsStatusReasonsResponse,
    (request: messages_claims_message_pb.UpsertClaimsStatusReasonsRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.UpsertClaimsStatusReasonsResponse.deserializeBinary
  );

  upsertClaimsStatusReasons(
    request: messages_claims_message_pb.UpsertClaimsStatusReasonsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.UpsertClaimsStatusReasonsResponse>;

  upsertClaimsStatusReasons(
    request: messages_claims_message_pb.UpsertClaimsStatusReasonsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.UpsertClaimsStatusReasonsResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.UpsertClaimsStatusReasonsResponse>;

  upsertClaimsStatusReasons(
    request: messages_claims_message_pb.UpsertClaimsStatusReasonsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.UpsertClaimsStatusReasonsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/UpsertClaimsStatusReasons',
        request,
        metadata || {},
        this.methodDescriptorUpsertClaimsStatusReasons,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/UpsertClaimsStatusReasons',
    request,
    metadata || {},
    this.methodDescriptorUpsertClaimsStatusReasons);
  }

  methodDescriptorgetPolicyIdByMemberId = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/getPolicyIdByMemberId',
    grpcWeb.MethodType.UNARY,
    messages_members_message_pb.GetPolicyIdByMemberIdRequest,
    messages_members_message_pb.GetPolicyIdByMemberIdResponse,
    (request: messages_members_message_pb.GetPolicyIdByMemberIdRequest) => {
      return request.serializeBinary();
    },
    messages_members_message_pb.GetPolicyIdByMemberIdResponse.deserializeBinary
  );

  getPolicyIdByMemberId(
    request: messages_members_message_pb.GetPolicyIdByMemberIdRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_members_message_pb.GetPolicyIdByMemberIdResponse>;

  getPolicyIdByMemberId(
    request: messages_members_message_pb.GetPolicyIdByMemberIdRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_members_message_pb.GetPolicyIdByMemberIdResponse) => void): grpcWeb.ClientReadableStream<messages_members_message_pb.GetPolicyIdByMemberIdResponse>;

  getPolicyIdByMemberId(
    request: messages_members_message_pb.GetPolicyIdByMemberIdRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_members_message_pb.GetPolicyIdByMemberIdResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/getPolicyIdByMemberId',
        request,
        metadata || {},
        this.methodDescriptorgetPolicyIdByMemberId,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/getPolicyIdByMemberId',
    request,
    metadata || {},
    this.methodDescriptorgetPolicyIdByMemberId);
  }

  methodDescriptorhasPolicyByMemberId = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/hasPolicyByMemberId',
    grpcWeb.MethodType.UNARY,
    messages_members_message_pb.HasPolicyByMemberIdRequest,
    messages_members_message_pb.HasPolicyByMemberIdResponse,
    (request: messages_members_message_pb.HasPolicyByMemberIdRequest) => {
      return request.serializeBinary();
    },
    messages_members_message_pb.HasPolicyByMemberIdResponse.deserializeBinary
  );

  hasPolicyByMemberId(
    request: messages_members_message_pb.HasPolicyByMemberIdRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_members_message_pb.HasPolicyByMemberIdResponse>;

  hasPolicyByMemberId(
    request: messages_members_message_pb.HasPolicyByMemberIdRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_members_message_pb.HasPolicyByMemberIdResponse) => void): grpcWeb.ClientReadableStream<messages_members_message_pb.HasPolicyByMemberIdResponse>;

  hasPolicyByMemberId(
    request: messages_members_message_pb.HasPolicyByMemberIdRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_members_message_pb.HasPolicyByMemberIdResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/hasPolicyByMemberId',
        request,
        metadata || {},
        this.methodDescriptorhasPolicyByMemberId,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/hasPolicyByMemberId',
    request,
    metadata || {},
    this.methodDescriptorhasPolicyByMemberId);
  }

  methodDescriptorisPremiumPaid = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/isPremiumPaid',
    grpcWeb.MethodType.UNARY,
    messages_members_message_pb.IsPremiumPaidRequest,
    messages_members_message_pb.IsPremiumPaidResponse,
    (request: messages_members_message_pb.IsPremiumPaidRequest) => {
      return request.serializeBinary();
    },
    messages_members_message_pb.IsPremiumPaidResponse.deserializeBinary
  );

  isPremiumPaid(
    request: messages_members_message_pb.IsPremiumPaidRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_members_message_pb.IsPremiumPaidResponse>;

  isPremiumPaid(
    request: messages_members_message_pb.IsPremiumPaidRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_members_message_pb.IsPremiumPaidResponse) => void): grpcWeb.ClientReadableStream<messages_members_message_pb.IsPremiumPaidResponse>;

  isPremiumPaid(
    request: messages_members_message_pb.IsPremiumPaidRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_members_message_pb.IsPremiumPaidResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/isPremiumPaid',
        request,
        metadata || {},
        this.methodDescriptorisPremiumPaid,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/isPremiumPaid',
    request,
    metadata || {},
    this.methodDescriptorisPremiumPaid);
  }

  methodDescriptorDownloadDoc = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/DownloadDoc',
    grpcWeb.MethodType.UNARY,
    messages_file_message_pb.DownloadFileRequest,
    messages_file_message_pb.DownloadFileResponse,
    (request: messages_file_message_pb.DownloadFileRequest) => {
      return request.serializeBinary();
    },
    messages_file_message_pb.DownloadFileResponse.deserializeBinary
  );

  downloadDoc(
    request: messages_file_message_pb.DownloadFileRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_file_message_pb.DownloadFileResponse>;

  downloadDoc(
    request: messages_file_message_pb.DownloadFileRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_file_message_pb.DownloadFileResponse) => void): grpcWeb.ClientReadableStream<messages_file_message_pb.DownloadFileResponse>;

  downloadDoc(
    request: messages_file_message_pb.DownloadFileRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_file_message_pb.DownloadFileResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/DownloadDoc',
        request,
        metadata || {},
        this.methodDescriptorDownloadDoc,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/DownloadDoc',
    request,
    metadata || {},
    this.methodDescriptorDownloadDoc);
  }

  methodDescriptorDownloadDocStream = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/DownloadDocStream',
    grpcWeb.MethodType.SERVER_STREAMING,
    messages_file_message_pb.DownloadFileRequest,
    messages_file_message_pb.DownloadFileChunkResponse,
    (request: messages_file_message_pb.DownloadFileRequest) => {
      return request.serializeBinary();
    },
    messages_file_message_pb.DownloadFileChunkResponse.deserializeBinary
  );

  downloadDocStream(
    request: messages_file_message_pb.DownloadFileRequest,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<messages_file_message_pb.DownloadFileChunkResponse> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/claims_bff_api.ClaimsBFFController/DownloadDocStream',
      request,
      metadata || {},
      this.methodDescriptorDownloadDocStream);
  }

  methodDescriptorGetCase = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetCase',
    grpcWeb.MethodType.UNARY,
    messages_cases_message_pb.GetCaseRequest,
    messages_cases_message_pb.GetCaseResponse,
    (request: messages_cases_message_pb.GetCaseRequest) => {
      return request.serializeBinary();
    },
    messages_cases_message_pb.GetCaseResponse.deserializeBinary
  );

  getCase(
    request: messages_cases_message_pb.GetCaseRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_cases_message_pb.GetCaseResponse>;

  getCase(
    request: messages_cases_message_pb.GetCaseRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_cases_message_pb.GetCaseResponse) => void): grpcWeb.ClientReadableStream<messages_cases_message_pb.GetCaseResponse>;

  getCase(
    request: messages_cases_message_pb.GetCaseRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_cases_message_pb.GetCaseResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetCase',
        request,
        metadata || {},
        this.methodDescriptorGetCase,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetCase',
    request,
    metadata || {},
    this.methodDescriptorGetCase);
  }

  methodDescriptorGetClaimsLampCase = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetClaimsLampCase',
    grpcWeb.MethodType.UNARY,
    messages_cases_message_pb.GetClaimsLampCaseRequest,
    messages_cases_message_pb.GetClaimsLampCaseResponse,
    (request: messages_cases_message_pb.GetClaimsLampCaseRequest) => {
      return request.serializeBinary();
    },
    messages_cases_message_pb.GetClaimsLampCaseResponse.deserializeBinary
  );

  getClaimsLampCase(
    request: messages_cases_message_pb.GetClaimsLampCaseRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_cases_message_pb.GetClaimsLampCaseResponse>;

  getClaimsLampCase(
    request: messages_cases_message_pb.GetClaimsLampCaseRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_cases_message_pb.GetClaimsLampCaseResponse) => void): grpcWeb.ClientReadableStream<messages_cases_message_pb.GetClaimsLampCaseResponse>;

  getClaimsLampCase(
    request: messages_cases_message_pb.GetClaimsLampCaseRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_cases_message_pb.GetClaimsLampCaseResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetClaimsLampCase',
        request,
        metadata || {},
        this.methodDescriptorGetClaimsLampCase,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetClaimsLampCase',
    request,
    metadata || {},
    this.methodDescriptorGetClaimsLampCase);
  }

  methodDescriptorGetLampCase = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetLampCase',
    grpcWeb.MethodType.UNARY,
    messages_cases_message_pb.GetLampCaseRequest,
    messages_cases_message_pb.GetLampCaseResponse,
    (request: messages_cases_message_pb.GetLampCaseRequest) => {
      return request.serializeBinary();
    },
    messages_cases_message_pb.GetLampCaseResponse.deserializeBinary
  );

  getLampCase(
    request: messages_cases_message_pb.GetLampCaseRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_cases_message_pb.GetLampCaseResponse>;

  getLampCase(
    request: messages_cases_message_pb.GetLampCaseRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_cases_message_pb.GetLampCaseResponse) => void): grpcWeb.ClientReadableStream<messages_cases_message_pb.GetLampCaseResponse>;

  getLampCase(
    request: messages_cases_message_pb.GetLampCaseRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_cases_message_pb.GetLampCaseResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetLampCase',
        request,
        metadata || {},
        this.methodDescriptorGetLampCase,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetLampCase',
    request,
    metadata || {},
    this.methodDescriptorGetLampCase);
  }

  methodDescriptorSearchMatchedCases = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/SearchMatchedCases',
    grpcWeb.MethodType.UNARY,
    messages_cases_message_pb.CaseSearchRequest,
    messages_cases_message_pb.CaseSearchResponse,
    (request: messages_cases_message_pb.CaseSearchRequest) => {
      return request.serializeBinary();
    },
    messages_cases_message_pb.CaseSearchResponse.deserializeBinary
  );

  searchMatchedCases(
    request: messages_cases_message_pb.CaseSearchRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_cases_message_pb.CaseSearchResponse>;

  searchMatchedCases(
    request: messages_cases_message_pb.CaseSearchRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_cases_message_pb.CaseSearchResponse) => void): grpcWeb.ClientReadableStream<messages_cases_message_pb.CaseSearchResponse>;

  searchMatchedCases(
    request: messages_cases_message_pb.CaseSearchRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_cases_message_pb.CaseSearchResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/SearchMatchedCases',
        request,
        metadata || {},
        this.methodDescriptorSearchMatchedCases,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/SearchMatchedCases',
    request,
    metadata || {},
    this.methodDescriptorSearchMatchedCases);
  }

  methodDescriptorListCases = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/ListCases',
    grpcWeb.MethodType.UNARY,
    messages_cases_message_pb.CasesListRequest,
    messages_cases_message_pb.CasesListResponse,
    (request: messages_cases_message_pb.CasesListRequest) => {
      return request.serializeBinary();
    },
    messages_cases_message_pb.CasesListResponse.deserializeBinary
  );

  listCases(
    request: messages_cases_message_pb.CasesListRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_cases_message_pb.CasesListResponse>;

  listCases(
    request: messages_cases_message_pb.CasesListRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_cases_message_pb.CasesListResponse) => void): grpcWeb.ClientReadableStream<messages_cases_message_pb.CasesListResponse>;

  listCases(
    request: messages_cases_message_pb.CasesListRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_cases_message_pb.CasesListResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/ListCases',
        request,
        metadata || {},
        this.methodDescriptorListCases,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/ListCases',
    request,
    metadata || {},
    this.methodDescriptorListCases);
  }

  methodDescriptorSearchProviders = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/SearchProviders',
    grpcWeb.MethodType.UNARY,
    messages_providers_message_pb.ProvidersSearchRequest,
    messages_providers_message_pb.ProvidersSearchResponse,
    (request: messages_providers_message_pb.ProvidersSearchRequest) => {
      return request.serializeBinary();
    },
    messages_providers_message_pb.ProvidersSearchResponse.deserializeBinary
  );

  searchProviders(
    request: messages_providers_message_pb.ProvidersSearchRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_providers_message_pb.ProvidersSearchResponse>;

  searchProviders(
    request: messages_providers_message_pb.ProvidersSearchRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.ProvidersSearchResponse) => void): grpcWeb.ClientReadableStream<messages_providers_message_pb.ProvidersSearchResponse>;

  searchProviders(
    request: messages_providers_message_pb.ProvidersSearchRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.ProvidersSearchResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/SearchProviders',
        request,
        metadata || {},
        this.methodDescriptorSearchProviders,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/SearchProviders',
    request,
    metadata || {},
    this.methodDescriptorSearchProviders);
  }

  methodDescriptorGetProvider = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetProvider',
    grpcWeb.MethodType.UNARY,
    messages_providers_message_pb.ProvidersGetRequest,
    messages_providers_message_pb.ProvidersGetResponse,
    (request: messages_providers_message_pb.ProvidersGetRequest) => {
      return request.serializeBinary();
    },
    messages_providers_message_pb.ProvidersGetResponse.deserializeBinary
  );

  getProvider(
    request: messages_providers_message_pb.ProvidersGetRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_providers_message_pb.ProvidersGetResponse>;

  getProvider(
    request: messages_providers_message_pb.ProvidersGetRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.ProvidersGetResponse) => void): grpcWeb.ClientReadableStream<messages_providers_message_pb.ProvidersGetResponse>;

  getProvider(
    request: messages_providers_message_pb.ProvidersGetRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.ProvidersGetResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetProvider',
        request,
        metadata || {},
        this.methodDescriptorGetProvider,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetProvider',
    request,
    metadata || {},
    this.methodDescriptorGetProvider);
  }

  methodDescriptorGetProviderNotificationPreferencesByUserId = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetProviderNotificationPreferencesByUserId',
    grpcWeb.MethodType.UNARY,
    messages_providers_message_pb.ProvidersGetNotificationPreferencesRequest,
    messages_providers_message_pb.ProvidersGetNotificationPreferencesResponse,
    (request: messages_providers_message_pb.ProvidersGetNotificationPreferencesRequest) => {
      return request.serializeBinary();
    },
    messages_providers_message_pb.ProvidersGetNotificationPreferencesResponse.deserializeBinary
  );

  getProviderNotificationPreferencesByUserId(
    request: messages_providers_message_pb.ProvidersGetNotificationPreferencesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_providers_message_pb.ProvidersGetNotificationPreferencesResponse>;

  getProviderNotificationPreferencesByUserId(
    request: messages_providers_message_pb.ProvidersGetNotificationPreferencesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.ProvidersGetNotificationPreferencesResponse) => void): grpcWeb.ClientReadableStream<messages_providers_message_pb.ProvidersGetNotificationPreferencesResponse>;

  getProviderNotificationPreferencesByUserId(
    request: messages_providers_message_pb.ProvidersGetNotificationPreferencesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.ProvidersGetNotificationPreferencesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetProviderNotificationPreferencesByUserId',
        request,
        metadata || {},
        this.methodDescriptorGetProviderNotificationPreferencesByUserId,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetProviderNotificationPreferencesByUserId',
    request,
    metadata || {},
    this.methodDescriptorGetProviderNotificationPreferencesByUserId);
  }

  methodDescriptorUpdateProviderNotificationPreferencesByUserId = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/UpdateProviderNotificationPreferencesByUserId',
    grpcWeb.MethodType.UNARY,
    messages_providers_message_pb.ProvidersUpdateNotificationPreferencesRequest,
    messages_providers_message_pb.ProvidersUpdateNotificationPreferencesResponse,
    (request: messages_providers_message_pb.ProvidersUpdateNotificationPreferencesRequest) => {
      return request.serializeBinary();
    },
    messages_providers_message_pb.ProvidersUpdateNotificationPreferencesResponse.deserializeBinary
  );

  updateProviderNotificationPreferencesByUserId(
    request: messages_providers_message_pb.ProvidersUpdateNotificationPreferencesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_providers_message_pb.ProvidersUpdateNotificationPreferencesResponse>;

  updateProviderNotificationPreferencesByUserId(
    request: messages_providers_message_pb.ProvidersUpdateNotificationPreferencesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.ProvidersUpdateNotificationPreferencesResponse) => void): grpcWeb.ClientReadableStream<messages_providers_message_pb.ProvidersUpdateNotificationPreferencesResponse>;

  updateProviderNotificationPreferencesByUserId(
    request: messages_providers_message_pb.ProvidersUpdateNotificationPreferencesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.ProvidersUpdateNotificationPreferencesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/UpdateProviderNotificationPreferencesByUserId',
        request,
        metadata || {},
        this.methodDescriptorUpdateProviderNotificationPreferencesByUserId,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/UpdateProviderNotificationPreferencesByUserId',
    request,
    metadata || {},
    this.methodDescriptorUpdateProviderNotificationPreferencesByUserId);
  }

  methodDescriptorGetProviderRates = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetProviderRates',
    grpcWeb.MethodType.UNARY,
    messages_providers_message_pb.GetProviderRatesRequest,
    messages_providers_message_pb.GetProviderRatesResponse,
    (request: messages_providers_message_pb.GetProviderRatesRequest) => {
      return request.serializeBinary();
    },
    messages_providers_message_pb.GetProviderRatesResponse.deserializeBinary
  );

  getProviderRates(
    request: messages_providers_message_pb.GetProviderRatesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_providers_message_pb.GetProviderRatesResponse>;

  getProviderRates(
    request: messages_providers_message_pb.GetProviderRatesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.GetProviderRatesResponse) => void): grpcWeb.ClientReadableStream<messages_providers_message_pb.GetProviderRatesResponse>;

  getProviderRates(
    request: messages_providers_message_pb.GetProviderRatesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.GetProviderRatesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetProviderRates',
        request,
        metadata || {},
        this.methodDescriptorGetProviderRates,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetProviderRates',
    request,
    metadata || {},
    this.methodDescriptorGetProviderRates);
  }

  methodDescriptorUpsertProviderRate = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/UpsertProviderRate',
    grpcWeb.MethodType.UNARY,
    messages_providers_message_pb.UpsertProviderRateRequest,
    messages_providers_message_pb.UpsertProviderRateResponse,
    (request: messages_providers_message_pb.UpsertProviderRateRequest) => {
      return request.serializeBinary();
    },
    messages_providers_message_pb.UpsertProviderRateResponse.deserializeBinary
  );

  upsertProviderRate(
    request: messages_providers_message_pb.UpsertProviderRateRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_providers_message_pb.UpsertProviderRateResponse>;

  upsertProviderRate(
    request: messages_providers_message_pb.UpsertProviderRateRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.UpsertProviderRateResponse) => void): grpcWeb.ClientReadableStream<messages_providers_message_pb.UpsertProviderRateResponse>;

  upsertProviderRate(
    request: messages_providers_message_pb.UpsertProviderRateRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.UpsertProviderRateResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/UpsertProviderRate',
        request,
        metadata || {},
        this.methodDescriptorUpsertProviderRate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/UpsertProviderRate',
    request,
    metadata || {},
    this.methodDescriptorUpsertProviderRate);
  }

  methodDescriptorDeleteProviderRate = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/DeleteProviderRate',
    grpcWeb.MethodType.UNARY,
    messages_providers_message_pb.DeleteProviderRateRequest,
    messages_providers_message_pb.DeleteProviderRateResponse,
    (request: messages_providers_message_pb.DeleteProviderRateRequest) => {
      return request.serializeBinary();
    },
    messages_providers_message_pb.DeleteProviderRateResponse.deserializeBinary
  );

  deleteProviderRate(
    request: messages_providers_message_pb.DeleteProviderRateRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_providers_message_pb.DeleteProviderRateResponse>;

  deleteProviderRate(
    request: messages_providers_message_pb.DeleteProviderRateRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.DeleteProviderRateResponse) => void): grpcWeb.ClientReadableStream<messages_providers_message_pb.DeleteProviderRateResponse>;

  deleteProviderRate(
    request: messages_providers_message_pb.DeleteProviderRateRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.DeleteProviderRateResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/DeleteProviderRate',
        request,
        metadata || {},
        this.methodDescriptorDeleteProviderRate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/DeleteProviderRate',
    request,
    metadata || {},
    this.methodDescriptorDeleteProviderRate);
  }

  methodDescriptorGetBillsForCase = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetBillsForCase',
    grpcWeb.MethodType.UNARY,
    messages_payments_message_pb.PaymentsGetBillsForCaseRequest,
    messages_payments_message_pb.PaymentsGetBillsForCaseResponse,
    (request: messages_payments_message_pb.PaymentsGetBillsForCaseRequest) => {
      return request.serializeBinary();
    },
    messages_payments_message_pb.PaymentsGetBillsForCaseResponse.deserializeBinary
  );

  getBillsForCase(
    request: messages_payments_message_pb.PaymentsGetBillsForCaseRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_payments_message_pb.PaymentsGetBillsForCaseResponse>;

  getBillsForCase(
    request: messages_payments_message_pb.PaymentsGetBillsForCaseRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_payments_message_pb.PaymentsGetBillsForCaseResponse) => void): grpcWeb.ClientReadableStream<messages_payments_message_pb.PaymentsGetBillsForCaseResponse>;

  getBillsForCase(
    request: messages_payments_message_pb.PaymentsGetBillsForCaseRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_payments_message_pb.PaymentsGetBillsForCaseResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetBillsForCase',
        request,
        metadata || {},
        this.methodDescriptorGetBillsForCase,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetBillsForCase',
    request,
    metadata || {},
    this.methodDescriptorGetBillsForCase);
  }

  methodDescriptorGetBillsForClaim = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetBillsForClaim',
    grpcWeb.MethodType.UNARY,
    messages_payments_message_pb.PaymentsGetBillsForClaimRequest,
    messages_payments_message_pb.PaymentsGetBillsForClaimResponse,
    (request: messages_payments_message_pb.PaymentsGetBillsForClaimRequest) => {
      return request.serializeBinary();
    },
    messages_payments_message_pb.PaymentsGetBillsForClaimResponse.deserializeBinary
  );

  getBillsForClaim(
    request: messages_payments_message_pb.PaymentsGetBillsForClaimRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_payments_message_pb.PaymentsGetBillsForClaimResponse>;

  getBillsForClaim(
    request: messages_payments_message_pb.PaymentsGetBillsForClaimRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_payments_message_pb.PaymentsGetBillsForClaimResponse) => void): grpcWeb.ClientReadableStream<messages_payments_message_pb.PaymentsGetBillsForClaimResponse>;

  getBillsForClaim(
    request: messages_payments_message_pb.PaymentsGetBillsForClaimRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_payments_message_pb.PaymentsGetBillsForClaimResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetBillsForClaim',
        request,
        metadata || {},
        this.methodDescriptorGetBillsForClaim,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetBillsForClaim',
    request,
    metadata || {},
    this.methodDescriptorGetBillsForClaim);
  }

  methodDescriptorListLegalBenefits = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/ListLegalBenefits',
    grpcWeb.MethodType.UNARY,
    messages_benefits_message_pb.ListLegalBenefitsRequest,
    messages_benefits_message_pb.ListLegalBenefitsResponse,
    (request: messages_benefits_message_pb.ListLegalBenefitsRequest) => {
      return request.serializeBinary();
    },
    messages_benefits_message_pb.ListLegalBenefitsResponse.deserializeBinary
  );

  listLegalBenefits(
    request: messages_benefits_message_pb.ListLegalBenefitsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_benefits_message_pb.ListLegalBenefitsResponse>;

  listLegalBenefits(
    request: messages_benefits_message_pb.ListLegalBenefitsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_benefits_message_pb.ListLegalBenefitsResponse) => void): grpcWeb.ClientReadableStream<messages_benefits_message_pb.ListLegalBenefitsResponse>;

  listLegalBenefits(
    request: messages_benefits_message_pb.ListLegalBenefitsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_benefits_message_pb.ListLegalBenefitsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/ListLegalBenefits',
        request,
        metadata || {},
        this.methodDescriptorListLegalBenefits,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/ListLegalBenefits',
    request,
    metadata || {},
    this.methodDescriptorListLegalBenefits);
  }

  methodDescriptorGetLegalBenefitById = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetLegalBenefitById',
    grpcWeb.MethodType.UNARY,
    messages_benefits_message_pb.GetLegalBenefitByIdRequest,
    messages_benefits_message_pb.GetLegalBenefitByIdResponse,
    (request: messages_benefits_message_pb.GetLegalBenefitByIdRequest) => {
      return request.serializeBinary();
    },
    messages_benefits_message_pb.GetLegalBenefitByIdResponse.deserializeBinary
  );

  getLegalBenefitById(
    request: messages_benefits_message_pb.GetLegalBenefitByIdRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_benefits_message_pb.GetLegalBenefitByIdResponse>;

  getLegalBenefitById(
    request: messages_benefits_message_pb.GetLegalBenefitByIdRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_benefits_message_pb.GetLegalBenefitByIdResponse) => void): grpcWeb.ClientReadableStream<messages_benefits_message_pb.GetLegalBenefitByIdResponse>;

  getLegalBenefitById(
    request: messages_benefits_message_pb.GetLegalBenefitByIdRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_benefits_message_pb.GetLegalBenefitByIdResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetLegalBenefitById',
        request,
        metadata || {},
        this.methodDescriptorGetLegalBenefitById,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetLegalBenefitById',
    request,
    metadata || {},
    this.methodDescriptorGetLegalBenefitById);
  }

  methodDescriptorListMatterBillingCodes = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/ListMatterBillingCodes',
    grpcWeb.MethodType.UNARY,
    messages_benefits_message_pb.ListMatterBillingCodesRequest,
    messages_benefits_message_pb.ListMatterBillingCodesResponse,
    (request: messages_benefits_message_pb.ListMatterBillingCodesRequest) => {
      return request.serializeBinary();
    },
    messages_benefits_message_pb.ListMatterBillingCodesResponse.deserializeBinary
  );

  listMatterBillingCodes(
    request: messages_benefits_message_pb.ListMatterBillingCodesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_benefits_message_pb.ListMatterBillingCodesResponse>;

  listMatterBillingCodes(
    request: messages_benefits_message_pb.ListMatterBillingCodesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_benefits_message_pb.ListMatterBillingCodesResponse) => void): grpcWeb.ClientReadableStream<messages_benefits_message_pb.ListMatterBillingCodesResponse>;

  listMatterBillingCodes(
    request: messages_benefits_message_pb.ListMatterBillingCodesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_benefits_message_pb.ListMatterBillingCodesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/ListMatterBillingCodes',
        request,
        metadata || {},
        this.methodDescriptorListMatterBillingCodes,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/ListMatterBillingCodes',
    request,
    metadata || {},
    this.methodDescriptorListMatterBillingCodes);
  }

  methodDescriptorCreateNote = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/CreateNote',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.CreateNoteRequest,
    messages_claims_message_pb.CreateNoteResponse,
    (request: messages_claims_message_pb.CreateNoteRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.CreateNoteResponse.deserializeBinary
  );

  createNote(
    request: messages_claims_message_pb.CreateNoteRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.CreateNoteResponse>;

  createNote(
    request: messages_claims_message_pb.CreateNoteRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.CreateNoteResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.CreateNoteResponse>;

  createNote(
    request: messages_claims_message_pb.CreateNoteRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.CreateNoteResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/CreateNote',
        request,
        metadata || {},
        this.methodDescriptorCreateNote,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/CreateNote',
    request,
    metadata || {},
    this.methodDescriptorCreateNote);
  }

  methodDescriptorGetNote = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetNote',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.GetNoteByIdRequest,
    messages_claims_message_pb.GetNoteByIdResponse,
    (request: messages_claims_message_pb.GetNoteByIdRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.GetNoteByIdResponse.deserializeBinary
  );

  getNote(
    request: messages_claims_message_pb.GetNoteByIdRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.GetNoteByIdResponse>;

  getNote(
    request: messages_claims_message_pb.GetNoteByIdRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetNoteByIdResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.GetNoteByIdResponse>;

  getNote(
    request: messages_claims_message_pb.GetNoteByIdRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetNoteByIdResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetNote',
        request,
        metadata || {},
        this.methodDescriptorGetNote,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetNote',
    request,
    metadata || {},
    this.methodDescriptorGetNote);
  }

  methodDescriptorGetNotes = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetNotes',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.GetNotesByIdRequest,
    messages_claims_message_pb.GetNotesByIdResponse,
    (request: messages_claims_message_pb.GetNotesByIdRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.GetNotesByIdResponse.deserializeBinary
  );

  getNotes(
    request: messages_claims_message_pb.GetNotesByIdRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.GetNotesByIdResponse>;

  getNotes(
    request: messages_claims_message_pb.GetNotesByIdRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetNotesByIdResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.GetNotesByIdResponse>;

  getNotes(
    request: messages_claims_message_pb.GetNotesByIdRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetNotesByIdResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetNotes',
        request,
        metadata || {},
        this.methodDescriptorGetNotes,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetNotes',
    request,
    metadata || {},
    this.methodDescriptorGetNotes);
  }

  methodDescriptorDeleteNote = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/DeleteNote',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.DeleteNoteRequest,
    messages_claims_message_pb.DeleteNoteResponse,
    (request: messages_claims_message_pb.DeleteNoteRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.DeleteNoteResponse.deserializeBinary
  );

  deleteNote(
    request: messages_claims_message_pb.DeleteNoteRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.DeleteNoteResponse>;

  deleteNote(
    request: messages_claims_message_pb.DeleteNoteRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.DeleteNoteResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.DeleteNoteResponse>;

  deleteNote(
    request: messages_claims_message_pb.DeleteNoteRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.DeleteNoteResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/DeleteNote',
        request,
        metadata || {},
        this.methodDescriptorDeleteNote,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/DeleteNote',
    request,
    metadata || {},
    this.methodDescriptorDeleteNote);
  }

  methodDescriptorGetNotesByClaim = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetNotesByClaim',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.GetNotesByClaimRequest,
    messages_claims_message_pb.GetNotesByClaimResponse,
    (request: messages_claims_message_pb.GetNotesByClaimRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.GetNotesByClaimResponse.deserializeBinary
  );

  getNotesByClaim(
    request: messages_claims_message_pb.GetNotesByClaimRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.GetNotesByClaimResponse>;

  getNotesByClaim(
    request: messages_claims_message_pb.GetNotesByClaimRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetNotesByClaimResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.GetNotesByClaimResponse>;

  getNotesByClaim(
    request: messages_claims_message_pb.GetNotesByClaimRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetNotesByClaimResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetNotesByClaim',
        request,
        metadata || {},
        this.methodDescriptorGetNotesByClaim,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetNotesByClaim',
    request,
    metadata || {},
    this.methodDescriptorGetNotesByClaim);
  }

  methodDescriptorGetPinnedNotesByClaim = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetPinnedNotesByClaim',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.GetPinnedNotesByClaimRequest,
    messages_claims_message_pb.GetPinnedNotesByClaimResponse,
    (request: messages_claims_message_pb.GetPinnedNotesByClaimRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.GetPinnedNotesByClaimResponse.deserializeBinary
  );

  getPinnedNotesByClaim(
    request: messages_claims_message_pb.GetPinnedNotesByClaimRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.GetPinnedNotesByClaimResponse>;

  getPinnedNotesByClaim(
    request: messages_claims_message_pb.GetPinnedNotesByClaimRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetPinnedNotesByClaimResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.GetPinnedNotesByClaimResponse>;

  getPinnedNotesByClaim(
    request: messages_claims_message_pb.GetPinnedNotesByClaimRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetPinnedNotesByClaimResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetPinnedNotesByClaim',
        request,
        metadata || {},
        this.methodDescriptorGetPinnedNotesByClaim,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetPinnedNotesByClaim',
    request,
    metadata || {},
    this.methodDescriptorGetPinnedNotesByClaim);
  }

  methodDescriptorGetNotesByUser = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetNotesByUser',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.GetNotesByUserRequest,
    messages_claims_message_pb.GetNotesByUserResponse,
    (request: messages_claims_message_pb.GetNotesByUserRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.GetNotesByUserResponse.deserializeBinary
  );

  getNotesByUser(
    request: messages_claims_message_pb.GetNotesByUserRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.GetNotesByUserResponse>;

  getNotesByUser(
    request: messages_claims_message_pb.GetNotesByUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetNotesByUserResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.GetNotesByUserResponse>;

  getNotesByUser(
    request: messages_claims_message_pb.GetNotesByUserRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetNotesByUserResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetNotesByUser',
        request,
        metadata || {},
        this.methodDescriptorGetNotesByUser,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetNotesByUser',
    request,
    metadata || {},
    this.methodDescriptorGetNotesByUser);
  }

  methodDescriptorPinNote = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/PinNote',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.PinNoteRequest,
    messages_claims_message_pb.PinNoteResponse,
    (request: messages_claims_message_pb.PinNoteRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.PinNoteResponse.deserializeBinary
  );

  pinNote(
    request: messages_claims_message_pb.PinNoteRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.PinNoteResponse>;

  pinNote(
    request: messages_claims_message_pb.PinNoteRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.PinNoteResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.PinNoteResponse>;

  pinNote(
    request: messages_claims_message_pb.PinNoteRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.PinNoteResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/PinNote',
        request,
        metadata || {},
        this.methodDescriptorPinNote,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/PinNote',
    request,
    metadata || {},
    this.methodDescriptorPinNote);
  }

  methodDescriptorUnpinNote = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/UnpinNote',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.UnpinNoteRequest,
    messages_claims_message_pb.UnpinNoteResponse,
    (request: messages_claims_message_pb.UnpinNoteRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.UnpinNoteResponse.deserializeBinary
  );

  unpinNote(
    request: messages_claims_message_pb.UnpinNoteRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.UnpinNoteResponse>;

  unpinNote(
    request: messages_claims_message_pb.UnpinNoteRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.UnpinNoteResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.UnpinNoteResponse>;

  unpinNote(
    request: messages_claims_message_pb.UnpinNoteRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.UnpinNoteResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/UnpinNote',
        request,
        metadata || {},
        this.methodDescriptorUnpinNote,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/UnpinNote',
    request,
    metadata || {},
    this.methodDescriptorUnpinNote);
  }

  methodDescriptorSearchNotes = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/SearchNotes',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.SearchNotesRequest,
    messages_claims_message_pb.SearchNotesResponse,
    (request: messages_claims_message_pb.SearchNotesRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.SearchNotesResponse.deserializeBinary
  );

  searchNotes(
    request: messages_claims_message_pb.SearchNotesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.SearchNotesResponse>;

  searchNotes(
    request: messages_claims_message_pb.SearchNotesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.SearchNotesResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.SearchNotesResponse>;

  searchNotes(
    request: messages_claims_message_pb.SearchNotesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.SearchNotesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/SearchNotes',
        request,
        metadata || {},
        this.methodDescriptorSearchNotes,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/SearchNotes',
    request,
    metadata || {},
    this.methodDescriptorSearchNotes);
  }

  methodDescriptorGetActivityTypes = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetActivityTypes',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.GetActivityTypesRequest,
    messages_claims_message_pb.GetActivityTypesResponse,
    (request: messages_claims_message_pb.GetActivityTypesRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.GetActivityTypesResponse.deserializeBinary
  );

  getActivityTypes(
    request: messages_claims_message_pb.GetActivityTypesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.GetActivityTypesResponse>;

  getActivityTypes(
    request: messages_claims_message_pb.GetActivityTypesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetActivityTypesResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.GetActivityTypesResponse>;

  getActivityTypes(
    request: messages_claims_message_pb.GetActivityTypesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetActivityTypesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetActivityTypes',
        request,
        metadata || {},
        this.methodDescriptorGetActivityTypes,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetActivityTypes',
    request,
    metadata || {},
    this.methodDescriptorGetActivityTypes);
  }

  methodDescriptorGetActivitiesByClaimId = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetActivitiesByClaimId',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.GetActivitiesByClaimIdRequest,
    messages_claims_message_pb.GetActivitiesByClaimIdResponse,
    (request: messages_claims_message_pb.GetActivitiesByClaimIdRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.GetActivitiesByClaimIdResponse.deserializeBinary
  );

  getActivitiesByClaimId(
    request: messages_claims_message_pb.GetActivitiesByClaimIdRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.GetActivitiesByClaimIdResponse>;

  getActivitiesByClaimId(
    request: messages_claims_message_pb.GetActivitiesByClaimIdRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetActivitiesByClaimIdResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.GetActivitiesByClaimIdResponse>;

  getActivitiesByClaimId(
    request: messages_claims_message_pb.GetActivitiesByClaimIdRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetActivitiesByClaimIdResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetActivitiesByClaimId',
        request,
        metadata || {},
        this.methodDescriptorGetActivitiesByClaimId,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetActivitiesByClaimId',
    request,
    metadata || {},
    this.methodDescriptorGetActivitiesByClaimId);
  }

  methodDescriptorGetAnalysts = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetAnalysts',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.GetAnalystsRequest,
    messages_claims_message_pb.GetAnalystsResponse,
    (request: messages_claims_message_pb.GetAnalystsRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.GetAnalystsResponse.deserializeBinary
  );

  getAnalysts(
    request: messages_claims_message_pb.GetAnalystsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.GetAnalystsResponse>;

  getAnalysts(
    request: messages_claims_message_pb.GetAnalystsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetAnalystsResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.GetAnalystsResponse>;

  getAnalysts(
    request: messages_claims_message_pb.GetAnalystsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetAnalystsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetAnalysts',
        request,
        metadata || {},
        this.methodDescriptorGetAnalysts,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetAnalysts',
    request,
    metadata || {},
    this.methodDescriptorGetAnalysts);
  }

  methodDescriptorCreateClaimReservation = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/CreateClaimReservation',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.CreateClaimReservationRequest,
    messages_claims_message_pb.CreateClaimReservationResponse,
    (request: messages_claims_message_pb.CreateClaimReservationRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.CreateClaimReservationResponse.deserializeBinary
  );

  createClaimReservation(
    request: messages_claims_message_pb.CreateClaimReservationRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.CreateClaimReservationResponse>;

  createClaimReservation(
    request: messages_claims_message_pb.CreateClaimReservationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.CreateClaimReservationResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.CreateClaimReservationResponse>;

  createClaimReservation(
    request: messages_claims_message_pb.CreateClaimReservationRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.CreateClaimReservationResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/CreateClaimReservation',
        request,
        metadata || {},
        this.methodDescriptorCreateClaimReservation,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/CreateClaimReservation',
    request,
    metadata || {},
    this.methodDescriptorCreateClaimReservation);
  }

  methodDescriptorRemoveClaimReservation = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/RemoveClaimReservation',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.RemoveClaimReservationRequest,
    messages_claims_message_pb.RemoveClaimReservationResponse,
    (request: messages_claims_message_pb.RemoveClaimReservationRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.RemoveClaimReservationResponse.deserializeBinary
  );

  removeClaimReservation(
    request: messages_claims_message_pb.RemoveClaimReservationRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.RemoveClaimReservationResponse>;

  removeClaimReservation(
    request: messages_claims_message_pb.RemoveClaimReservationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.RemoveClaimReservationResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.RemoveClaimReservationResponse>;

  removeClaimReservation(
    request: messages_claims_message_pb.RemoveClaimReservationRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.RemoveClaimReservationResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/RemoveClaimReservation',
        request,
        metadata || {},
        this.methodDescriptorRemoveClaimReservation,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/RemoveClaimReservation',
    request,
    metadata || {},
    this.methodDescriptorRemoveClaimReservation);
  }

  methodDescriptorRecoverClaimReservation = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/RecoverClaimReservation',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.RecoverClaimReservationRequest,
    messages_claims_message_pb.RecoverClaimReservationResponse,
    (request: messages_claims_message_pb.RecoverClaimReservationRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.RecoverClaimReservationResponse.deserializeBinary
  );

  recoverClaimReservation(
    request: messages_claims_message_pb.RecoverClaimReservationRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.RecoverClaimReservationResponse>;

  recoverClaimReservation(
    request: messages_claims_message_pb.RecoverClaimReservationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.RecoverClaimReservationResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.RecoverClaimReservationResponse>;

  recoverClaimReservation(
    request: messages_claims_message_pb.RecoverClaimReservationRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.RecoverClaimReservationResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/RecoverClaimReservation',
        request,
        metadata || {},
        this.methodDescriptorRecoverClaimReservation,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/RecoverClaimReservation',
    request,
    metadata || {},
    this.methodDescriptorRecoverClaimReservation);
  }

  methodDescriptorListClaimReservations = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/ListClaimReservations',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.ListClaimReservationsRequest,
    messages_claims_message_pb.ListClaimReservationsResponse,
    (request: messages_claims_message_pb.ListClaimReservationsRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.ListClaimReservationsResponse.deserializeBinary
  );

  listClaimReservations(
    request: messages_claims_message_pb.ListClaimReservationsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.ListClaimReservationsResponse>;

  listClaimReservations(
    request: messages_claims_message_pb.ListClaimReservationsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ListClaimReservationsResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.ListClaimReservationsResponse>;

  listClaimReservations(
    request: messages_claims_message_pb.ListClaimReservationsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.ListClaimReservationsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/ListClaimReservations',
        request,
        metadata || {},
        this.methodDescriptorListClaimReservations,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/ListClaimReservations',
    request,
    metadata || {},
    this.methodDescriptorListClaimReservations);
  }

  methodDescriptorGetClaimReservation = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetClaimReservation',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.GetClaimReservationRequest,
    messages_claims_message_pb.GetClaimReservationResponse,
    (request: messages_claims_message_pb.GetClaimReservationRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.GetClaimReservationResponse.deserializeBinary
  );

  getClaimReservation(
    request: messages_claims_message_pb.GetClaimReservationRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.GetClaimReservationResponse>;

  getClaimReservation(
    request: messages_claims_message_pb.GetClaimReservationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetClaimReservationResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.GetClaimReservationResponse>;

  getClaimReservation(
    request: messages_claims_message_pb.GetClaimReservationRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetClaimReservationResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetClaimReservation',
        request,
        metadata || {},
        this.methodDescriptorGetClaimReservation,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetClaimReservation',
    request,
    metadata || {},
    this.methodDescriptorGetClaimReservation);
  }

  methodDescriptorGetClaimReservationFormData = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetClaimReservationFormData',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.GetClaimReservationFormDataRequest,
    messages_claims_message_pb.GetClaimReservationFormDataResponse,
    (request: messages_claims_message_pb.GetClaimReservationFormDataRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.GetClaimReservationFormDataResponse.deserializeBinary
  );

  getClaimReservationFormData(
    request: messages_claims_message_pb.GetClaimReservationFormDataRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.GetClaimReservationFormDataResponse>;

  getClaimReservationFormData(
    request: messages_claims_message_pb.GetClaimReservationFormDataRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetClaimReservationFormDataResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.GetClaimReservationFormDataResponse>;

  getClaimReservationFormData(
    request: messages_claims_message_pb.GetClaimReservationFormDataRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.GetClaimReservationFormDataResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetClaimReservationFormData',
        request,
        metadata || {},
        this.methodDescriptorGetClaimReservationFormData,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetClaimReservationFormData',
    request,
    metadata || {},
    this.methodDescriptorGetClaimReservationFormData);
  }

  methodDescriptorGetStates = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetStates',
    grpcWeb.MethodType.UNARY,
    messages_core_message_pb.GetStatesRequest,
    messages_core_message_pb.GetStatesResponse,
    (request: messages_core_message_pb.GetStatesRequest) => {
      return request.serializeBinary();
    },
    messages_core_message_pb.GetStatesResponse.deserializeBinary
  );

  getStates(
    request: messages_core_message_pb.GetStatesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_core_message_pb.GetStatesResponse>;

  getStates(
    request: messages_core_message_pb.GetStatesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_core_message_pb.GetStatesResponse) => void): grpcWeb.ClientReadableStream<messages_core_message_pb.GetStatesResponse>;

  getStates(
    request: messages_core_message_pb.GetStatesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_core_message_pb.GetStatesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetStates',
        request,
        metadata || {},
        this.methodDescriptorGetStates,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetStates',
    request,
    metadata || {},
    this.methodDescriptorGetStates);
  }

  methodDescriptorGetClaimsBffVersion = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GetClaimsBffVersion',
    grpcWeb.MethodType.UNARY,
    messages_core_message_pb.GetClaimsBffVersionRequest,
    messages_core_message_pb.GetClaimsBffVersionResponse,
    (request: messages_core_message_pb.GetClaimsBffVersionRequest) => {
      return request.serializeBinary();
    },
    messages_core_message_pb.GetClaimsBffVersionResponse.deserializeBinary
  );

  getClaimsBffVersion(
    request: messages_core_message_pb.GetClaimsBffVersionRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_core_message_pb.GetClaimsBffVersionResponse>;

  getClaimsBffVersion(
    request: messages_core_message_pb.GetClaimsBffVersionRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_core_message_pb.GetClaimsBffVersionResponse) => void): grpcWeb.ClientReadableStream<messages_core_message_pb.GetClaimsBffVersionResponse>;

  getClaimsBffVersion(
    request: messages_core_message_pb.GetClaimsBffVersionRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_core_message_pb.GetClaimsBffVersionResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GetClaimsBffVersion',
        request,
        metadata || {},
        this.methodDescriptorGetClaimsBffVersion,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GetClaimsBffVersion',
    request,
    metadata || {},
    this.methodDescriptorGetClaimsBffVersion);
  }

  methodDescriptorCheckForDuplicateClaim = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/CheckForDuplicateClaim',
    grpcWeb.MethodType.UNARY,
    messages_claims_message_pb.CheckForDuplicateClaimRequest,
    messages_claims_message_pb.CheckForDuplicateClaimResponse,
    (request: messages_claims_message_pb.CheckForDuplicateClaimRequest) => {
      return request.serializeBinary();
    },
    messages_claims_message_pb.CheckForDuplicateClaimResponse.deserializeBinary
  );

  checkForDuplicateClaim(
    request: messages_claims_message_pb.CheckForDuplicateClaimRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_claims_message_pb.CheckForDuplicateClaimResponse>;

  checkForDuplicateClaim(
    request: messages_claims_message_pb.CheckForDuplicateClaimRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.CheckForDuplicateClaimResponse) => void): grpcWeb.ClientReadableStream<messages_claims_message_pb.CheckForDuplicateClaimResponse>;

  checkForDuplicateClaim(
    request: messages_claims_message_pb.CheckForDuplicateClaimRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_claims_message_pb.CheckForDuplicateClaimResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/CheckForDuplicateClaim',
        request,
        metadata || {},
        this.methodDescriptorCheckForDuplicateClaim,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/CheckForDuplicateClaim',
    request,
    metadata || {},
    this.methodDescriptorCheckForDuplicateClaim);
  }

  methodDescriptorRenderPdf = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/RenderPdf',
    grpcWeb.MethodType.UNARY,
    messages_pdf_message_pb.RenderRequest,
    messages_pdf_message_pb.RenderResponse,
    (request: messages_pdf_message_pb.RenderRequest) => {
      return request.serializeBinary();
    },
    messages_pdf_message_pb.RenderResponse.deserializeBinary
  );

  renderPdf(
    request: messages_pdf_message_pb.RenderRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_pdf_message_pb.RenderResponse>;

  renderPdf(
    request: messages_pdf_message_pb.RenderRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_pdf_message_pb.RenderResponse) => void): grpcWeb.ClientReadableStream<messages_pdf_message_pb.RenderResponse>;

  renderPdf(
    request: messages_pdf_message_pb.RenderRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_pdf_message_pb.RenderResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/RenderPdf',
        request,
        metadata || {},
        this.methodDescriptorRenderPdf,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/RenderPdf',
    request,
    metadata || {},
    this.methodDescriptorRenderPdf);
  }

  methodDescriptorGenerateCcsPdf = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GenerateCcsPdf',
    grpcWeb.MethodType.UNARY,
    messages_pdf_message_pb.GenerateCcsPdfRequest,
    messages_pdf_message_pb.GenerateCcsPdfResponse,
    (request: messages_pdf_message_pb.GenerateCcsPdfRequest) => {
      return request.serializeBinary();
    },
    messages_pdf_message_pb.GenerateCcsPdfResponse.deserializeBinary
  );

  generateCcsPdf(
    request: messages_pdf_message_pb.GenerateCcsPdfRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_pdf_message_pb.GenerateCcsPdfResponse>;

  generateCcsPdf(
    request: messages_pdf_message_pb.GenerateCcsPdfRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_pdf_message_pb.GenerateCcsPdfResponse) => void): grpcWeb.ClientReadableStream<messages_pdf_message_pb.GenerateCcsPdfResponse>;

  generateCcsPdf(
    request: messages_pdf_message_pb.GenerateCcsPdfRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_pdf_message_pb.GenerateCcsPdfResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GenerateCcsPdf',
        request,
        metadata || {},
        this.methodDescriptorGenerateCcsPdf,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GenerateCcsPdf',
    request,
    metadata || {},
    this.methodDescriptorGenerateCcsPdf);
  }

  methodDescriptorGenerateCcsPdfBatch = new grpcWeb.MethodDescriptor(
    '/claims_bff_api.ClaimsBFFController/GenerateCcsPdfBatch',
    grpcWeb.MethodType.UNARY,
    messages_pdf_message_pb.GenerateCcsPdfBatchRequest,
    messages_pdf_message_pb.GenerateCcsPdfBatchResponse,
    (request: messages_pdf_message_pb.GenerateCcsPdfBatchRequest) => {
      return request.serializeBinary();
    },
    messages_pdf_message_pb.GenerateCcsPdfBatchResponse.deserializeBinary
  );

  generateCcsPdfBatch(
    request: messages_pdf_message_pb.GenerateCcsPdfBatchRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_pdf_message_pb.GenerateCcsPdfBatchResponse>;

  generateCcsPdfBatch(
    request: messages_pdf_message_pb.GenerateCcsPdfBatchRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_pdf_message_pb.GenerateCcsPdfBatchResponse) => void): grpcWeb.ClientReadableStream<messages_pdf_message_pb.GenerateCcsPdfBatchResponse>;

  generateCcsPdfBatch(
    request: messages_pdf_message_pb.GenerateCcsPdfBatchRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_pdf_message_pb.GenerateCcsPdfBatchResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/claims_bff_api.ClaimsBFFController/GenerateCcsPdfBatch',
        request,
        metadata || {},
        this.methodDescriptorGenerateCcsPdfBatch,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/claims_bff_api.ClaimsBFFController/GenerateCcsPdfBatch',
    request,
    metadata || {},
    this.methodDescriptorGenerateCcsPdfBatch);
  }

}

